(function () {
    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['tanker'] = i18n['tanker'] || {};

    i18n['tanker']['dynamic'] = {
        gender: function (params) {
            return (function (params) {
                return params[params.gender];
            })(params);
        },
        plural: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count,
                    lastNumber = count % 10,
                    lastNumbers = count % 100;

                return lastNumber == 1 && lastNumbers != 11
                    ? params.one
                    : lastNumber > 1 && lastNumber < 5 && (lastNumbers < 10 || lastNumbers > 20)
                      ? params.some
                      : params.many;
            })(params);
        },
        plural_adv: function (params) {
            return (function (params) {
                var count = isNaN(parseInt(params.count)) ? 0 : params.count;

                if (count === 0) {
                    return params.none;
                }

                return i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: params['one'],
                    some: params['some'],
                    many: params['many'],
                });
            })(params);
        },
        toggle: function (params) {
            return (function (params) {
                return Boolean(params.condition) ? params['true'] : params['false'];
            })(params);
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['broadcast-view'] = {
        'broadcast-start-countdown': function (params) {
            return 'Yayının başlaması için kalan süre';
        },
        'broadcast-start-countdown-ended': function (params) {
            return 'Toplantıyı düzenleyen kısa süre içinde yayını başlatacak';
        },
        'broadcast-start-date': function (params) {
            return params['date'] + ', ' + params['time'];
        },
        'broadcast-start-date-title': function (params) {
            return 'Yayın başlıyor';
        },
        'broadcast-stopped': function (params) {
            return 'Yayın durduruldu. Toplantıyı düzenleyen kısa süre sonra yayını sürdürecek';
        },
        'created-by': function (params) {
            return 'Düzenleyen: ' + params['name'];
        },
        'started-at': function (params) {
            return 'Yayın ' + params['time'] + ' itibarıyla başladı';
        },
        'viewers-count': function (params) {
            return 'Şu anda ' + params['count'] + ' kişi izliyor';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['call'] = {
        'additional-number-template': function (params) {
            return 'Dahili: ' + params['number'];
        },
        'broadcast-link': function (params) {
            return 'Yayın bağlantısı';
        },
        'call-connecting': function (params) {
            return 'Bağlantı kuruluyor';
        },
        'call-into-meeting': function (params) {
            return 'Toplantıyı ara';
        },
        'copy-invitation': function (params) {
            return 'Daveti kopyala';
        },
        'invitation-copied': function (params) {
            return 'Davet kopyalandı';
        },
        'invitation-header': function (params) {
            return "Yandex Telemost'ta toplantı";
        },
        'invite-participants': function (params) {
            return 'Katılımcıları davet et';
        },
        link: function (params) {
            return 'Görüntülü toplantı bağlantısı';
        },
        'link-copied': function (params) {
            return 'Bağlantı kopyalandı';
        },
        'link-copied-on-start': function (params) {
            return 'Toplantı bağlantısı kopyalandı';
        },
        'link-successfully-copied': function (params) {
            return 'Bağlantı kopyalandı';
        },
        'meeting-link': function (params) {
            return 'Toplantı bağlantısı';
        },
        'network-quality-status-bad-another': function (params) {
            return 'Bu katılımcının bağlantısı zayıf';
        },
        'network-quality-status-bad-self': function (params) {
            return 'Bağlantınız zayıf';
        },
        'outgoing-call': function (params) {
            return 'Giden arama';
        },
        'participant-video-limited': function (params) {
            return 'Bu kullanıcı için\nvideo kısıtlamaları\nuygulanmıştır';
        },
        'participants-count': function (params) {
            return (
                'Toplantıda ' +
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'kişi var',
                    some: 'kişi var',
                    many: 'kişi var',
                })
            );
        },
        'participants-list': function (params) {
            return 'Katılımcı listesi';
        },
        'phone-invitation-header': function (params) {
            return 'Yandex Telemost toplantısını ara';
        },
        'phone-number-copied': function (params) {
            return 'Numara kopyalandı';
        },
        'phone-template': function (params) {
            return params['phone'] + ', dahili ' + params['number'];
        },
        'share-link-copy-button': function (params) {
            return 'Bağlantıyı tekrar kopyala';
        },
        'share-link-copy-button-on-blur': function (params) {
            return 'Bağlantıyı kopyala';
        },
        'share-link-copy-button-success': function (params) {
            return 'Bağlantı zaten kopyalandı';
        },
        'share-link-meeting-number': function (params) {
            return 'Toplantı No.: ' + params['number'];
        },
        'share-link-messenger': function (params) {
            return "Yandex Messenger'a gönder";
        },
        'share-link-slack': function (params) {
            return "Slack'e gönder";
        },
        'share-link-tg': function (params) {
            return "Telegram'a gönder";
        },
        'share-link-title': function (params) {
            return 'Başka katılımcılar davet etmek için\nonlara toplantı bağlantısını gönderin';
        },
        'share-link-whatsapp': function (params) {
            return "WhatsApp'a gönder";
        },
        'sso-account-suggest': function (params) {
            return 'İş hesabınız varsa, onunla bağlanmanızı öneririz';
        },
        'video-limited-reason-network': function (params) {
            return 'Zayıf bağlantı nedeniyle video görüntülenemiyor';
        },
        'video-limited-reason-room-size': function (params) {
            return 'Katılımcı konuştuğunda video görüntülenecektir';
        },
        'video-limited-reason-self': function (params) {
            return 'Katılımcının videosunu gizlediniz';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['chats'] = {
        broadcast_description: function (params) {
            return 'Toplantı zamanı, düzenleyenin saat diliminde belirtilmiştir. Sohbet adı değiştirilebilir. [İzleyiciler için bağlantı](%broadcast-uri%)';
        },
        broadcast_system_message: function (params) {
            return 'Bu sohbet odası, izleyiciler ve toplantıyı düzenleyenler için ortak bir sohbet odasıdır. Yayını paylaşmak için [bu bağlantıyı](%broadcast-uri%) gönderin';
        },
        broadcast_title: function (params) {
            return 'Telemost yayınıdır. Sohbet, %date% itibarıyla oluşturulmuştur.';
        },
        noname_title: function (params) {
            return 'Telemost yayını';
        },
        nonpermanent_description: function (params) {
            return 'Toplantının başlangıç saati, düzenleyenin saat diliminde belirtilmiştir: [hangout referansı](%conference-uri%).';
        },
        nonpermanent_title: function (params) {
            return "Telemost'ta toplantı günü: %date%";
        },
        permanent_description: function (params) {
            return 'Toplantı zamanı, düzenleyenin saat diliminde belirtilmiştir. Sohberin adı değiştirilebilir. [Video toplantısı bağlantısı](%conference-uri%).';
        },
        permanent_title: function (params) {
            return "Telemost'ta toplantı (sohbetin oluşturulması: %date%)";
        },
        system_message: function (params) {
            return "Yandex'e kullanıcı girişi yaptıysanız sohbet Yandex Messenger'a kaydedilecektir.";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['cloud-recording'] = {
        'stop-modal-cancel': function (params) {
            return 'Hayır';
        },
        'stop-modal-confirm': function (params) {
            return 'Evet';
        },
        'stop-modal-description': function (params) {
            return 'Kayıt herkes için duracak. Bağlantı, bir süre sonra toplantıyı düzenleyenin sohbetinde ve e-postasında görünecek. İşlemin tamamlanması zaman alabilir.';
        },
        'stop-modal-header': function (params) {
            return "Yandex Disk'e kayıt durdurulsun mu?";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['common'] = {
        admit: function (params) {
            return 'İçeri al';
        },
        'admit-all': function (params) {
            return 'Herkesi içeri al';
        },
        'admit-to-limit': function (params) {
            return 'Katılımcı sayısı limiti kadar içeri al';
        },
        back: function (params) {
            return 'Geri';
        },
        cancel: function (params) {
            return 'İptal';
        },
        'change-account': function (params) {
            return 'Hesabı değiştir';
        },
        'close-dialog': function (params) {
            return 'Pencereyi kapat';
        },
        continue: function (params) {
            return 'Devam';
        },
        'continue-in-browser': function (params) {
            return 'Tarayıcıda devam et';
        },
        'copy-link': function (params) {
            return 'Bağlantıyı kopyala';
        },
        'copy-link-action': function (params) {
            return 'Bağlantıyı kopyala';
        },
        'copy-link-short': function (params) {
            return 'Kopyala';
        },
        'copy-link-to-conf': function (params) {
            return 'Toplantı bağlantısını kopyala';
        },
        'got-it': function (params) {
            return 'Anladım';
        },
        guest: function (params) {
            return 'Konuk';
        },
        install: function (params) {
            return 'Yükle';
        },
        'install-app': function (params) {
            return 'Uygulamayı kur';
        },
        'install-app-v2': function (params) {
            return 'Masaüstü uygulaması';
        },
        'install-mobile-app': function (params) {
            return 'Mobil uygulama';
        },
        'install-mobile-app-message': function (params) {
            return 'Mobil uygulamayı indir';
        },
        login: function (params) {
            return 'Giriş yap';
        },
        logout: function (params) {
            return 'Çıkış yap';
        },
        name: function (params) {
            return 'İsim';
        },
        'not-now': function (params) {
            return 'Şimdi değil';
        },
        ok: function (params) {
            return 'Tamam';
        },
        'open-in-app': function (params) {
            return 'Uygulamada aç';
        },
        'organizer-revoked-admit-permission': function (params) {
            return '';
        },
        retry: function (params) {
            return 'Tekrar dene';
        },
        'retry-one-more-time': function (params) {
            return 'Tekrar dene';
        },
        'share-button-text': function (params) {
            return 'Toplantıya davet et';
        },
        'share-tooltip-text': function (params) {
            return 'Kişileri toplantıya davet et';
        },
        support: function (params) {
            return 'Destek';
        },
        'to-home': function (params) {
            return 'Ana sayfaya git';
        },
        'to-home-screen': function (params) {
            return 'Ana ekrana dön';
        },
        'try-app': function (params) {
            return 'Dene';
        },
        unwrap: function (params) {
            return 'Göster';
        },
        view: function (params) {
            return 'Görüntüle';
        },
        wrap: function (params) {
            return 'Gizle';
        },
        'yandex-disk-title': function (params) {
            return 'Yandex Disk';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['conferences-history'] = {
        'access-forbidden-contact-owner': function (params) {
            return 'Erişilemiyor. Toplantı sahipleriyle iletişime geçin';
        },
        'access-forbidden-contact-support': function (params) {
            return 'Erişilemiyor';
        },
        admins: function (params) {
            return 'Eş düzenleyenler';
        },
        'all-confs': function (params) {
            return 'Tüm toplantılar';
        },
        'batch-fetching-failed': function (params) {
            return 'Toplantıların bir kısmı yüklenmedi. Yenilemeyi deneyin';
        },
        'change-filters-hint': function (params) {
            return 'Filtreleri farklı şekilde ayarlamayı deneyin';
        },
        'cloud-recording': function (params) {
            return "Yandex Disk'e kayıt";
        },
        'conf-number': function (params) {
            return 'Toplantı numarası';
        },
        'conference-number': function (params) {
            return 'Toplantı no. ' + params['id'];
        },
        'conferences-history': function (params) {
            return 'Toplantı geçmişi';
        },
        'contact-support': function (params) {
            return "Destek Ekibi'ne yaz";
        },
        'copy-email': function (params) {
            return 'E-postayı kopyala';
        },
        day: function (params) {
            return '1 günlük';
        },
        'email-copied': function (params) {
            return 'E-posta afresi kopyalandı';
        },
        'empty-result-title': function (params) {
            return 'Geçmiş toplantılar burada görüntülenir';
        },
        'empty-result-title-active-filter': function (params) {
            return 'Böyle bir toplantı yok';
        },
        'fetching-error': function (params) {
            return 'Toplantı listesi yüklenemedi';
        },
        filter: function (params) {
            return 'Filtre';
        },
        'for-3-month': function (params) {
            return '3 aylık';
        },
        home: function (params) {
            return 'Ana sayfaya git';
        },
        'in-progress': function (params) {
            return 'İşleniyor';
        },
        'in-your-mail': function (params) {
            return 'E-posta kutunuzda';
        },
        'insufficient-disk-space': function (params) {
            return 'Kayıt yüklenemiyor; diskinizde yeterli yer yok';
        },
        'local-recording': function (params) {
            return 'Bilgisayara kayıt';
        },
        'meeting-report': function (params) {
            return 'Katılım raporu';
        },
        members: function (params) {
            return 'Katılımcılar';
        },
        'members-recording': function (params) {
            return 'Katılımcılar tarafından kaydedildi';
        },
        month: function (params) {
            return '1 aylık';
        },
        'no-artifacts': function (params) {
            return 'Materyaller olmadan';
        },
        other: function (params) {
            return 'Teknik bir sorun nedeniyle oluşturulamadı';
        },
        'other-summarization': function (params) {
            return 'Teknik bir sorun nedeniyle oluşturulamadı';
        },
        owner: function (params) {
            return 'Düzenleyen';
        },
        period: function (params) {
            return 'Belirlediğiniz dönem boyunca';
        },
        recording: function (params) {
            return 'Kayıt';
        },
        'recording-too-short': function (params) {
            return 'Oluşturulamadı. Kayıt 15 saniyeden kısa sürdü';
        },
        refresh: function (params) {
            return 'Yenile';
        },
        'report-error': function (params) {
            return 'Rapor, teknik bir sorun nedeniyle oluşturulamadı';
        },
        'report-error-common': function (params) {
            return 'Rapora ulaşılamıyor';
        },
        reset: function (params) {
            return 'Sıfırla';
        },
        'reset-filters': function (params) {
            return 'Filtreleri sıfırla';
        },
        'select-conference': function (params) {
            return 'Ayrıntıları görmek için bir toplantı seçin';
        },
        'send-to-email': function (params) {
            return 'E-postanıza gönderildi';
        },
        'show-more-recipients': function (params) {
            return params['count'] + ' katılımcı daha göster';
        },
        summarization: function (params) {
            return 'Özet';
        },
        'summarization-too-short': function (params) {
            return 'Oluşturulmadı. Not alma işlemi 30 saniyeden kısa sürmüş ya da tüm katılımcılar sessiz kalmış olabilir ';
        },
        today: function (params) {
            return 'bugün';
        },
        watch: function (params) {
            return 'İzle';
        },
        'who-receive': function (params) {
            return 'Alıcılar';
        },
        'who-recording': function (params) {
            return 'Kaydedenler';
        },
        'with-recording': function (params) {
            return 'Kayıt ile';
        },
        'with-report': function (params) {
            return 'Katılım raporu ile';
        },
        'with-summary': function (params) {
            return 'Özet ile';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-broadcast'] = {
        'access-level-organization': function (params) {
            return 'Çalışanlar için';
        },
        'access-level-public': function (params) {
            return 'Herkes için';
        },
        'broadcast-title-tooltip': function (params) {
            return 'Yayının adını katılımcılar ve izleyiciler görür';
        },
        'caption-placeholder': function (params) {
            return 'İsim';
        },
        'caption-placeholder-v2': function (params) {
            return 'Ad: İzleyiciler tarafından görülecektir';
        },
        'description-placeholder': function (params) {
            return 'Açıklama';
        },
        'form-title': function (params) {
            return 'Yeni yayın';
        },
        'start-button': function (params) {
            return 'Şimdi yayın oluştur';
        },
        'start-button-short': function (params) {
            return 'Hemen oluştur';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['create-call'] = {
        'app-description': function (params) {
            return 'Görüntülü toplantı oluşturup\nbağlantısını \nkatılımcılara gönderin.';
        },
        'broadcast-description': function (params) {
            return 'İzleyiciler için ayrı bağlantı var; video toplantısına sadece katılımcılar katılıyor';
        },
        'broadcast-text': function (params) {
            return 'Yeni yayın';
        },
        connect: function (params) {
            return 'Bağlan';
        },
        'connect-call-description': function (params) {
            return 'Bağlantıya veya\ntoplantı numarasına göre';
        },
        'connect-call-text': function (params) {
            return 'Bağlan';
        },
        'create-call-text': function (params) {
            return 'Görüntülü toplantı oluştur';
        },
        'disabled-broadcast-description': function (params) {
            return 'Tarifenizde kullanılamıyor';
        },
        'disabled-broadcast-description-more': function (params) {
            return 'Ayrıntılar';
        },
        'insert-link-or-meeting-number': function (params) {
            return 'Toplantı numarasını belirtin veya bağlantısını ekleyin';
        },
        'insert-link-or-meeting-number-notification': function (params) {
            return 'Toplantı numarasını girin veya toplantı bağlantısını ekleyin';
        },
        'install-button-tooltip': function (params) {
            return 'Program ile daha kolay';
        },
        'main-title': function (params) {
            return 'Yandex Telemost: Bağlantı üzerinden görüntülü toplantı';
        },
        'new-call-description': function (params) {
            return 'Başlamak üzere. Bağlantıyı katılımcılara gönderin';
        },
        'new-call-text': function (params) {
            return 'Yeni video toplantısı';
        },
        ok: function (params) {
            return 'Tamam';
        },
        'plan-call-description': function (params) {
            return 'Takvimde toplantı bağlantısı içeren bir etkinlik oluşturuluyor';
        },
        'plan-call-text': function (params) {
            return 'Planla';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['dtmf'] = {
        'command-list.audio.mute': function (params) {
            return 'Mikrofonu kapat';
        },
        'command-list.audio.unmute': function (params) {
            return 'Mikrofonu aç';
        },
        'command-list.gallery-view.turn-on': function (params) {
            return 'Galeri görünümünü etkinleştir';
        },
        'command-list.participant-list.open': function (params) {
            return 'Katılımcı listesi';
        },
        'command-list.participant-list.show': function (params) {
            return 'Katılımcı listesini göster';
        },
        'command-list.presenter-view.turn-on': function (params) {
            return 'Sunum görünümünü etkinleştir';
        },
        'command-list.reactions.hand-down': function (params) {
            return 'Elini indir';
        },
        'command-list.reactions.hand-up': function (params) {
            return 'Elini kaldır';
        },
        'command-list.subtitle': function (params) {
            return 'Tablet klavyesinde istediğiniz simgeye basın';
        },
        'command-list.title': function (params) {
            return 'Komut listesi';
        },
        'command-list.video.mute': function (params) {
            return 'Kamerayı kapat';
        },
        'command-list.video.unmute': function (params) {
            return 'Kamerayı aç';
        },
        'common.close': function (params) {
            return 'Kapat';
        },
        'gallery-view': function (params) {
            return 'Galeri görünümü';
        },
        'notification.camera-and-microphone-muted': function (params) {
            return 'Kamera ve mikrofon kapalı.';
        },
        'notification.camera-muted': function (params) {
            return 'Kamera kapalı';
        },
        'notification.hand-lower': function (params) {
            return 'Elini indir';
        },
        'notification.hand-raised': function (params) {
            return 'El kaldırıldı.';
        },
        'notification.microphone-muted': function (params) {
            return 'Mikrofon kapalı.';
        },
        'notification.recording': function (params) {
            return 'Kayıt devam ediyor';
        },
        'notification.summarization': function (params) {
            return 'Not tutuluyor';
        },
        'notification.turn-on': function (params) {
            return 'Aç';
        },
        'notification.turn-on-camera': function (params) {
            return 'Kamerayı aç';
        },
        'notification.turn-on-microphone': function (params) {
            return 'Mikrofonu aç';
        },
        'notification.waiting-room': function (params) {
            return 'Bekleme odasında katılımcılar var';
        },
        'pagination-next-page': function (params) {
            return 'Katılımcıları sağa kaydır';
        },
        'pagination-prev-page': function (params) {
            return 'Katılımcıları sola kaydır';
        },
        'participant-list.count': function (params) {
            return (
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'katılımcı',
                    some: 'katılımcı',
                    many: 'katılımcı',
                })
            );
        },
        'participant-list.next-page': function (params) {
            return 'Sonraki sayfa';
        },
        'participant-list.page-state': function (params) {
            return params['totalPages'] + ' sayfadan ' + params['currentPage'] + '. sayfa ';
        },
        'participant-list.prev-page': function (params) {
            return 'Önceki sayfa';
        },
        'presenter-view': function (params) {
            return 'Sunum görünümü';
        },
        'unmute-notification.both-camera-text': function (params) {
            return 'Kamerayı etkinleştir';
        },
        'unmute-notification.both-common-text': function (params) {
            return 'Kamera ve mikrofon kapalı.';
        },
        'unmute-notification.both-microphone-text': function (params) {
            return 'Mikrofonu etkinleştir';
        },
        'unmute-notification.camera-text': function (params) {
            return 'Kamera kapalı. Dahil etmek';
        },
        'unmute-notification.microphone-text': function (params) {
            return 'Mikrofon kapalı. Dahil etmek';
        },
        'unmute-notification.text': function (params) {
            return 'Toplantı odasındaki mikrofon kapalı. Açmak için sırayla simgelere tıklayın';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['error-page'] = {
        'ask-for-camera-and-mic-permissions': function (params) {
            return 'Kamera ve mikrofon\nerişimine izin ver';
        },
        'back-to-chats': function (params) {
            return 'Sohbetlere geri dön';
        },
        'broadcast-gone': function (params) {
            return 'Bu yayın sona erdi';
        },
        'broadcast-gone-v2': function (params) {
            return 'Yayın bitirilecek';
        },
        'broadcast-gone-v2-with-datetime': function (params) {
            return 'Yayın \n' + params['date'] + ' tarihinde ' + params['time'] + ' itibarıyla bitti ';
        },
        'broadcast-not-found': function (params) {
            return 'Yayın bulunamadı';
        },
        'broadcast-organization-mismatches-description': function (params) {
            return 'Bu yayına sadece kurum çalışanları katılabilir. Doğru kullanıcı hesabını seçtiğinizden emin olun.';
        },
        'broadcast-organization-mismatches-title': function (params) {
            return 'Bu özel bir yayındır';
        },
        'broadcast-organization-mismatches-unauthorized-description': function (params) {
            return 'Bu yayına sadece kurum çalışanları katılabilir. ';
        },
        'close-button-title': function (params) {
            return 'Kapat';
        },
        'default-title': function (params) {
            return 'Hata oluştu';
        },
        'forbidden-title': function (params) {
            return 'Erişim izni yok';
        },
        'gone-title': function (params) {
            return 'Bu toplantı sona erdi;\nisterseniz yenisini oluşturabilirsiniz';
        },
        'how-to-add-permission-link': function (params) {
            return 'Nasıl yapabilirim?';
        },
        'no-camera-and-mic-permissions': function (params) {
            return 'Kamera ve mikrofona erişim yok';
        },
        'no-device-permission-text': function (params) {
            return 'Görüntülü toplantı kullanılamıyor.\nKamera ve mikrofon erişimine izin verin.';
        },
        'not-found-title': function (params) {
            return 'Böyle bir toplantı yok;\nisterseniz yenisini oluşturabilirsiniz';
        },
        'not-in-experiment-title': function (params) {
            return 'Toplantı oluşturma özelliğini kullanamıyorsunuz.\nFakat davet edildiğinizde bağlanabilirsiniz';
        },
        'not-started-title': function (params) {
            return (
                'Bu toplantı henüz başlamadı. Toplantının tarihi: ' +
                params['date'] +
                ', saati: ' +
                params['time'] +
                '. Bağlanabileceğiniz zamana kadar kalan süre: ' +
                params['startTime'] +
                '.'
            );
        },
        'organization-mismatches-description': function (params) {
            return 'Sadece kurum çalışanları bu toplantıya katılabilir. Doğru kullanıcı hesabını seçtiğinizden emin olun.';
        },
        'organization-mismatches-title': function (params) {
            return 'Bu özel bir toplantı.';
        },
        'organization-mismatches-unauthorized-button': function (params) {
            return 'Hesaba giriş yap';
        },
        'organization-mismatches-unauthorized-description': function (params) {
            return 'Sadece kurum çalışanları bu toplantıya katılabilir.';
        },
        'organization-mismatches-yateam-button-primary': function (params) {
            return 'Hesabı değiştir';
        },
        'organization-mismatches-yateam-button-secondary': function (params) {
            return 'Uygulamaya git';
        },
        'organization-mismatches-yateam-description': function (params) {
            return 'İsterseniz uygulama üzerinden deneyin.\nKişisel kullanıcı hesbınızla iş toplantısına giremezsiniz';
        },
        'organization-mismatches-yateam-title': function (params) {
            return '@yandex-team.ru hesabına geçin';
        },
        'overloaded-title': function (params) {
            return 'Serviste şu anda aşırı yüklenme var fakat sorunu çözmeye çalışıyoruz.';
        },
        'try-calls-in-disk': function (params) {
            return "Yandex Disk'te \n  görüntülü toplantıyı deneyin";
        },
        'try-telemost-app': function (params) {
            return 'Telemost \nuygulamasını deneyin';
        },
        'unauthorized-subtitle': function (params) {
            return 'Toplantı oluşturmak için\nYandex hesabınıza giriş yapın';
        },
        'unauthorized-title': function (params) {
            return 'Bağlantı üzerinden görüntülü toplantı';
        },
        'unsupported-browser-subtitle': function (params) {
            return (
                'Bilgisayar için ' +
                '<x-link-disk>' +
                'Yandex Disk' +
                '</x-link-disk>' +
                ' uygulamasını kurun ya da\n ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                ', Google Chrome veya Mozilla Firefox kullanın'
            );
        },
        'unsupported-browser-subtitle-no-ff': function (params) {
            return (
                'Bilgisayar uygulamasını yükleyin\nya da ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                "'ı veya Google Chrome'u kullanın"
            );
        },
        'unsupported-browser-subtitle2': function (params) {
            return (
                'Bilgisayar uygulamasını yükleyin\nya da ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                ", Google Chrome veya Mozilla Firefox'u kullanın"
            );
        },
        'unsupported-browser-subtitle2-no-desktop': function (params) {
            return (
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                ', Google Chrome veya Mozilla Firefox kullanın'
            );
        },
        'unsupported-electron': function (params) {
            return "Yandex Telemost'un eski bir sürümünü kullanıyorsunuz ve bu sürümde artık görüntülü toplantılar desteklenmiyor. Kendi başına ayrı bir program olan Yandex Telemost'u indirin.";
        },
        'unsupported-electron-button': function (params) {
            return 'İndir';
        },
        'unsupported-messenger-description': function (params) {
            return (
                'Uygulamayı güncelleyin veya yeniden yükleyin. ' + '<x-link-help>' + 'Nasıl yapılır?' + '</x-link-help>'
            );
        },
        'unsupported-messenger-title': function (params) {
            return "Aramalar için Yandex Messenger'ın\nson sürümü gerekir";
        },
        'unsupported-mobile-bro-videocalls': function (params) {
            return 'Mobil tarayıcılarda görüntülü \ntoplantılar henüz kullanılamıyor.';
        },
        'unsupported-mobile-browser': function (params) {
            return 'Mobil tarayıcılarda \n bu özellik desteklenmiyor.';
        },
        'user-kicked-description': function (params) {
            return 'Biraz sonra tekrar bağlanmayı deneyin.';
        },
        'user-kicked-title': function (params) {
            return 'Bu toplantıdan çıkarıldınız';
        },
        'user-kicked-with-ban-description': function (params) {
            return 'Toplantı gün boyunca uygun değil; daha sonra bağlanmayı deneyin.';
        },
        'usupported-browser-title': function (params) {
            return 'Yandex Telemost\ntarayıcınızda çalışmıyor';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['faq'] = {
        'answer-1': function (params) {
            return 'Yandex Telemost, web bağlantısı üzerinden görüntülü toplantılar düzenlemeyi sağlayan bir servistir. Burada iş toplantıları, aile buluşmaları veya video partileri düzenleyebilirsiniz. Yapmanız gereken tek şey, toplantı oluşturup bağlantıyı arkadaşlarınızla paylaşmaktır.';
        },
        'answer-2': function (params) {
            return (
                "Telemost'u ücretsiz kullanıyorsanız, toplantıda en fazla 40 kişi olabilir. " +
                '<x-link-payment-plans>' +
                'Kurumlara özel tarifelerle' +
                '</x-link-payment-plans>' +
                ', toplantılar 1000 katılımcıya kadar genişletilebilir.'
            );
        },
        'answer-3': function (params) {
            return "Yandex Telemost'ta toplantı süresi için hiçbir sınırlama yok, böylece önemli görüşmeleriniz yarıda kesilmez.";
        },
        'answer-4': function (params) {
            return (
                "Evet, kullanabilirsiniz. Yandex Telemost'u ticari amaçlarla kullanabilmek için kurumunuzu, Kurumlar için Yandex 360'ta kaydedin. " +
                '<x-link-business>' +
                'Daha fazla bilgi ' +
                '</x-link-business>' +
                '\n'
            );
        },
        'answer-5': function (params) {
            return 'Yandex Telemost sayfasına gidin veya Yandex Telemost uygulamasını açın ve ardından "Planla"ya tıklayın. Toplantının tarihini ve saatini belirtin, katılımcıları ekleyin ve "Oluştur"a tıklayın. Böylece toplantınız Yandex Takvim\'inizde görüntülenir. Gerekirse toplantıyı Yandex Takvim\'den de planlayabilirsiniz: Yandex Takvim\'de her zamanki gibi bir etkinlik oluşturun ve ayarlarında "Görüntülü toplantı ekle"ye tıklayın.';
        },
        'answer-6': function (params) {
            return "Sanal arka planı Yandex Telemost'un web sürümünden şimdilik ayarlayamıyorsunuz; yalnızca bilgisayarda Yandex Telemost uygulaması üzerinden ayarlayabilirsiniz. Kullandığınız uygulamada bu ayarın bulunmaması işlemcinizin sanal arka planları desteklemediği anlamına gelebilir.";
        },
        'question-1': function (params) {
            return ' Yandex Telemost nedir?';
        },
        'question-2': function (params) {
            return 'Görüntülü toplantıya kaç kişi katılabilir?';
        },
        'question-3': function (params) {
            return 'Bir toplantının maksimum süresi nedir?';
        },
        'question-4': function (params) {
            return 'Yandex Telemost iş veya ticari amaçlarla kullanılabilir mi?';
        },
        'question-5': function (params) {
            return 'Toplantıyı önceden nasıl planlayabilirim?';
        },
        'question-6': function (params) {
            return "Yandex Telemost'ta sanal arka plan ayarı neden yok?";
        },
        title: function (params) {
            return 'Sıkça Sorulan Sorular';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['feedback'] = {
        cancel: function (params) {
            return 'Değerlendirmek istemiyorum';
        },
        comment: function (params) {
            return 'Yorum';
        },
        'contact-support': function (params) {
            return 'Destek ekibine yaz';
        },
        'feedback-description-hint': function (params) {
            return 'Durumu mümkün olduğunca ayrıntılı açıklayın, yaptığınız işlemleri ve sonuçlarını adım adım anlatın.';
        },
        'feedback-email-hint': function (params) {
            return 'Adres belirtin; yanıtı oraya göndereceğiz';
        },
        'feedback-form-header': function (params) {
            return 'Bağlantı kalitesini değerlendirin';
        },
        message: function (params) {
            return 'Geçmiş toplantılardaki\nbağlantı kalitesini değerlendirin';
        },
        'message-placeholder': function (params) {
            return 'Anlatın';
        },
        rate: function (params) {
            return 'Değerlendir';
        },
        'reason-bad-audio': function (params) {
            return 'Ses boğuk geliyor';
        },
        'reason-bad-video': function (params) {
            return 'Video kalitesi düşük';
        },
        'reason-disconnect': function (params) {
            return 'Toplantı kesildi ';
        },
        'reason-echo': function (params) {
            return 'Yankı veya gürültü geliyor';
        },
        'reason-no-audio': function (params) {
            return 'Sesim veya diğer konuşmacıların sesi gelmiyor';
        },
        'reason-no-video': function (params) {
            return 'Görüntüm veya diğer katılımcıların görüntüsü gelmiyor';
        },
        'reason-title': function (params) {
            return 'Neyi beğenmediğinizi\naçıklayın';
        },
        reason_audio_desync: function (params) {
            return 'Video ile ses senkronize değil';
        },
        reason_audio_distorted: function (params) {
            return 'Kesiliyor veya bozuluyor';
        },
        reason_audio_echo: function (params) {
            return 'Yankı var';
        },
        'reason_audio_no-data': function (params) {
            return 'Benden veya katılımcıdan ses duyulmuyor';
        },
        reason_audio_noise: function (params) {
            return 'Dış gürültü var';
        },
        reason_audio_volume: function (params) {
            return 'Çok yüksek veya çok düşük ses';
        },
        reason_group_audio: function (params) {
            return 'Ses';
        },
        reason_group_sharing: function (params) {
            return 'Ekran paylaşımı';
        },
        reason_group_video: function (params) {
            return 'Görüntü';
        },
        reason_sharing_distorted: function (params) {
            return 'Bozuluyor';
        },
        'reason_sharing_no-data': function (params) {
            return 'Açılmıyor';
        },
        reason_video_distorted: function (params) {
            return 'Bozuluyor';
        },
        reason_video_freezing: function (params) {
            return 'Donuyor';
        },
        'reason_video_no-data': function (params) {
            return 'Görüntüm veya diğer katılımcının görüntüsü gelmiyor';
        },
        'report-a-problem-button': function (params) {
            return 'Hata bildir';
        },
        'report-a-problem-form-header': function (params) {
            return 'Sorun bildir';
        },
        'send-feedback-error': function (params) {
            return 'Mesaj gönderilemedi.\nTekrar deneyin.';
        },
        'star-rate': function (params) {
            return params['index'] + '/' + params['count'] + ' yıldız seçin';
        },
        submit: function (params) {
            return 'Gönder';
        },
        'success-send-notification': function (params) {
            return "Bildiriminiz için teşekkürler. Telemost'un geliştirilmesine yardımcı oldunuz";
        },
        'success-send-notification-v2': function (params) {
            return 'Değerlendirmeniz için teşekkür ederiz';
        },
        title: function (params) {
            return 'Toplantıdan çıktınız';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['footer'] = {
        disclaimer: function (params) {
            return "Yandex Telemost'u kullanarak";
        },
        'terms-of-use': function (params) {
            return 'kullanıcı sözleşmesi koşullarını kabul etmiş sayılırsınız';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['header'] = {
        'app-description': function (params) {
            return 'Ücretsiz video konferanslar ve toplantılar doğrudan tarayıcınızda. Kayıt gerekmeden kişisel bilgisayarınızdan ve telefonunuzdan bağlanın. İşinizi yapın, dersinizi çalışın ve  çevrimiçi sohbet edin';
        },
        'app-join-description': function (params) {
            return 'Bağlanın ve süre kısıtlaması olmadan iletişim kurun';
        },
        'app-join-og-description': function (params) {
            return 'Bağlantıya tıklayarak aramaya bağlanabilirsiniz\n';
        },
        'app-telemessenger-chat-og-description': function (params) {
            return 'Bağlantıya tıklayarak sohbete bağlanabilirsiniz\n';
        },
        'app-telemessenger-description': function (params) {
            return 'Sohbet ve süre kısıtlaması olmayan görüntülü arama özellikleriyle mesajlaşın';
        },
        'app-telemessenger-invite-og-description': function (params) {
            return 'Bağlantıya tıkladığınızda özel sohbet açılır\n';
        },
        'join-og-title': function (params) {
            return "Yandex Telemost'ta arama\n";
        },
        'join-title': function (params) {
            return "Yandex Telemost'ta arama ";
        },
        logout: function (params) {
            return 'Çıkış';
        },
        'premium-button-text': function (params) {
            return 'Kurumlar için';
        },
        'premium-button-text-v2': function (params) {
            return 'Kurumlar için tarifeler';
        },
        'telemessenger-chat-og-title': function (params) {
            return "Yandex Telemost'ta sohbet\n";
        },
        'telemessenger-invite-og-title': function (params) {
            return "Sizi Yandex'e Telemost'a davet ediyorum\n";
        },
        'telemessenger-title': function (params) {
            return "Yandex Telemost'ta sohbet";
        },
        title: function (params) {
            return 'Yandex Telemost: Kayıt olma şartı ve süre sınırı olmaksızın ücretsiz görüntülü toplantılar';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['lists'] = {
        'months-genitive': function (params) {
            return 'Ocak | Şubat | Mart | Nisan | Mayıs | Haziran | Temmuz | Ağustos | Eylül | Ekim | Kasım | Aralık';
        },
        'months-nominative': function (params) {
            return 'Ocak | Şubat | Mart | Nisan | Mayıs | Haziran | Temmuz | Ağustos | Eylül | Ekim | Kasım | Aralık';
        },
        'week-days': function (params) {
            return 'pazar | pazartesi | salı | çarşamba | perşembe | cuma | cumartesi';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['moderation'] = {
        'access-level-organization': function (params) {
            return 'Yalnızca çalışanlar';
        },
        'access-level-public': function (params) {
            return 'Tüm kullanıcılar';
        },
        'access-level-waiting-room-admins': function (params) {
            return 'Herkes için bekleme odası';
        },
        'access-level-waiting-room-organization': function (params) {
            return 'Harici katılımcılar için bekleme odası';
        },
        'access-level-waiting-room-public': function (params) {
            return 'Bekleme odası devre dışı';
        },
        'action-change-avatar': function (params) {
            return 'Avatarı değiştir';
        },
        'action-change-name-and-avatar': function (params) {
            return 'Adı ve avatarı değiştir';
        },
        'action-kick-user': function (params) {
            return 'Toplantıdan çıkar';
        },
        'action-make-an-co-host': function (params) {
            return 'Eş düzenleyen yap';
        },
        'action-make-an-co-host-v2': function (params) {
            return '';
        },
        'action-make-an-moderator': function (params) {
            return 'Yönetici yap';
        },
        'action-mute-all-audio': function (params) {
            return 'Herkesin mikrofonunu kapat';
        },
        'action-mute-all-reactions-hand': function (params) {
            return 'Tüm elleri indir';
        },
        'action-mute-all-video': function (params) {
            return 'Herkesin kamerasını kapat';
        },
        'action-mute-reaction-hand': function (params) {
            return 'Elini indir';
        },
        'action-mute-screensharing': function (params) {
            return 'Ekran paylaşımını durdur';
        },
        'action-mute-video': function (params) {
            return 'Kamerayı kapat';
        },
        'action-stop-all-local-recordings': function (params) {
            return '';
        },
        'action-stop-local-recording': function (params) {
            return '';
        },
        'action-unmake-an-co-host': function (params) {
            return '';
        },
        'co-host': function (params) {
            return 'eş düzenleyen';
        },
        host: function (params) {
            return 'düzenleyen';
        },
        'modal-confirm-access-level-limit-text': function (params) {
            return 'Çalışanların bulunduğu bekleme odasında, toplantının alabileceğinden daha fazla kişi var';
        },
        'modal-confirm-access-level-limit-title': function (params) {
            return 'Çalışanların bir kısmı toplantıya katılamayacak';
        },
        'modal-confirm-end-call-button-confirm': function (params) {
            return 'Sonlandır';
        },
        'modal-confirm-end-call-content': function (params) {
            return 'Katılımcılar toplantıya katılıp tartışmaya devam edemeyecek';
        },
        'modal-confirm-end-call-header': function (params) {
            return 'Toplantı herkes için sonlandırılsın mı?';
        },
        'modal-confirm-end-call-with-broadcast-content': function (params) {
            return 'Yayın da sonlandırılacak';
        },
        'modal-kick-confirm-button-cancel': function (params) {
            return 'İptal';
        },
        'modal-kick-confirm-button-confirm': function (params) {
            return 'Sil';
        },
        'modal-kick-confirm-checkbox-label': function (params) {
            return '24 saat süre ile erişimi kapat';
        },
        'modal-kick-confirm-text': function (params) {
            return (
                'Toplantıdan çıkarılan ' +
                params['name'] +
                ' adlı katılımcı bu toplantıya daha sonra tekrar katılabilir.'
            );
        },
        'modal-kick-confirm-text-open': function (params) {
            return (
                'Toplantıdan çıkarılan ' +
                params['name'] +
                ' adlı katılımcı bu toplantıya daha sonra tekrar katılabilir. Söz konusu toplantı herkese açık.'
            );
        },
        'modal-kick-confirm-text-open-ban': function (params) {
            return 'Erişimi kısıtlamak ve toplantı katılımcılarını engellemek için katılımcı listesindeki erişim türünü değiştirin.';
        },
        'modal-kick-confirm-title': function (params) {
            return 'Toplantıdan çıkarılsın mı?';
        },
        'modal-stop-all-recordings-description': function (params) {
            return '';
        },
        'modal-stop-all-recordings-with-removal-label': function (params) {
            return '';
        },
        'modal-stop-recording-cancel-label': function (params) {
            return '';
        },
        'modal-stop-recording-confirm-label': function (params) {
            return '';
        },
        'modal-stop-recording-description': function (params) {
            return '';
        },
        'modal-stop-recording-header': function (params) {
            return '';
        },
        'modal-stop-recording-with-removal-label': function (params) {
            return '';
        },
        'modal-stop-recordings-header': function (params) {
            return '';
        },
        'notification-action-error': function (params) {
            return 'Hata oluştu. Tekrar deneyin.';
        },
        'notification-action-error-kick': function (params) {
            return 'Katılımcı çıkarılamadı. Tekrar deneyin';
        },
        'notification-action-error-make-an-co-host': function (params) {
            return 'Katılımcı, eş düzenleyen yapılamadı. Tekrar deneyin';
        },
        'notification-action-error-mute-all-audio': function (params) {
            return 'Tüm katılımcıların mikrofonları kapatılamadı. Tekrar deneyin.';
        },
        'notification-action-error-mute-all-recordings': function (params) {
            return '';
        },
        'notification-action-error-mute-all-video': function (params) {
            return 'Tüm katılımcıların kameraları kapatılamadı. Tekrar deneyin.';
        },
        'notification-action-error-mute-audio': function (params) {
            return 'Katılımcının mikrofonu kapatılamadı. Tekrar deneyin.';
        },
        'notification-action-error-mute-recording': function (params) {
            return '';
        },
        'notification-action-error-mute-recordings-no-permission': function (params) {
            return '';
        },
        'notification-action-error-mute-screensharing': function (params) {
            return 'Katılımcının ekran paylaşımı kapatılamadı. Tekrar deneyin.';
        },
        'notification-action-error-mute-video': function (params) {
            return 'Katılımcının kamerası kapatılamadı. Tekrar deneyin.';
        },
        'notification-action-error-permissions': function (params) {
            return 'Katılımcıların yetkileri düzenlenemedi';
        },
        'notification-action-error-set-broadcast-access-level': function (params) {
            return 'Yayın erişimi düzenlenemedi. Tekrar deneyin';
        },
        'notification-action-error-set-conference-access-level': function (params) {
            return 'Toplantı erişimi düzenlenemedi Tekrar deneyin';
        },
        'notification-action-success-mute-all-recordings': function (params) {
            return '';
        },
        'notification-action-success-mute-all-recordings-without-removal': function (params) {
            return '';
        },
        'notification-action-success-mute-recording': function (params) {
            return '';
        },
        'notification-action-success-mute-recording-without-removal': function (params) {
            return '';
        },
        'notification-confirm-ban-recording-content': function (params) {
            return 'Tutmaya başladığınız kayıt kaydedilmeyecektir';
        },
        'notification-confirm-ban-recording-header': function (params) {
            return 'Toplantıyı oluşturan kişi toplantı kaydını engelledi';
        },
        'notification-confirm-mute-recording-content': function (params) {
            return '';
        },
        'notification-confirm-mute-recording-header': function (params) {
            return '';
        },
        'notification-confirm-mute-recording-without-removal-content': function (params) {
            return '';
        },
        'notification-iam-new-co-host': function (params) {
            return params['name'] + ' sizi toplantının eş düzenleyeni yaptı';
        },
        'notification-iam-not-co-host': function (params) {
            return 'Artık bu toplantının eş düzenleyeni değilsiniz';
        },
        'notification-iam-not-co-host-v2': function (params) {
            return '';
        },
        'notification-kick': function (params) {
            return params['name'] + ' adlı katılımcıyı toplantıdan çıkardınız';
        },
        'notification-kick-with-ban': function (params) {
            return params['name'] + ' adlı katılımcıyı toplantıdan 24 saatliğine çıkardınız';
        },
        'notification-make-admin-error': function (params) {
            return '';
        },
        'notification-make-member-error': function (params) {
            return '';
        },
        'notification-my-audio-was-muted-by-co-host': function (params) {
            return 'Eş düzenleyen mikrofonunuzu kapattı';
        },
        'notification-my-audio-was-muted-by-host': function (params) {
            return 'Toplantıyı düzenleyen mikrofonunuzu kapattı';
        },
        'notification-my-recording-was-muted-by': function (params) {
            return '';
        },
        'notification-my-screensharing-was-muted-by-co-host': function (params) {
            return 'Eş düzenleyen ekran paylaşımınızı kapattı';
        },
        'notification-my-screensharing-was-muted-by-host': function (params) {
            return 'Toplantıyı düzenleyen ekran paylaşımınızı kapattı';
        },
        'notification-my-video-was-muted-by-co-host': function (params) {
            return 'Eş düzenleyen kameranızı kapattı';
        },
        'notification-my-video-was-muted-by-host': function (params) {
            return 'Toplantıyı düzenleyen kameranızı kapattı';
        },
        'notification-new-co-host': function (params) {
            return params['name'] + ' bu toplantının eş düzenleyeni oldu';
        },
        'notification-no-longer-co-host': function (params) {
            return params['name'] + ' artık bu toplantının eş düzenleyeni değil';
        },
        'notification-no-longer-co-host-v2': function (params) {
            return '';
        },
        'organizer-revoked-access-level-edit-permission': function (params) {
            return '';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['native-app-banner'] = {
        'app-description': function (params) {
            return 'Uygulamayı aç veya indir';
        },
        'app-name': function (params) {
            return 'Yandex Telemost';
        },
        'app-open-button': function (params) {
            return 'GİT';
        },
        description: function (params) {
            return '';
        },
        'download-app': function (params) {
            return '';
        },
        'download-telemost': function (params) {
            return '';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['new-call'] = {
        'go-on': function (params) {
            return 'Diğerine geç';
        },
        'modal-title': function (params) {
            return 'Zaten bir toplantıdasınız.' + params['spacebreak'] + 'Diğer toplantıya geçmek ister misiniz?';
        },
        'not-now': function (params) {
            return 'Şimdi değil';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['overlay'] = {
        'ask-for-introduction': function (params) {
            return 'Lütfen, kendinizi tanıtın';
        },
        'connect-call-button': function (params) {
            return 'Toplantıya bağlan';
        },
        'join-broadcast-button': function (params) {
            return 'Yayına bağlan';
        },
        'join-button': function (params) {
            return 'Bağlan';
        },
        'join-created-broadcast-description': function (params) {
            return 'Sadece katılımcılar sizi görecek. Videoyu ve sesi kontrol edin.';
        },
        'join-created-broadcast-title': function (params) {
            return 'Bağlanmaya hazır mısınız?';
        },
        'join-started-broadcast-description': function (params) {
            return 'Yayının tüm izleyicileri sizi görecek. Videoyu ve sesi kontrol edin.';
        },
        'join-started-broadcast-title': function (params) {
            return 'Bağlanmaya hazır mısınız?';
        },
        'nickname-title-label': function (params) {
            return 'Toplantıdaki adınız';
        },
        'no-fitting-account': function (params) {
            return '';
        },
        'quality-message': function (params) {
            return 'Toplantı tarayıcıda gerçekleşeceği için bağlantı kalitesi daha yüksek olacak';
        },
        'select-account': function (params) {
            return '';
        },
        'to-home-screen': function (params) {
            return '';
        },
        'waiting-room-status-1': function (params) {
            return 'Bekleme odasındasınız...';
        },
        'waiting-room-status-2': function (params) {
            return 'Toplantıyı düzenleyen kişi katılım talebinizi görüyor...';
        },
        'you-are-joining-text': function (params) {
            return (
                'Görüntülü toplantıya' +
                params['spacebreak'] +
                'bağlanıyorsunuz' +
                i18n['tanker']['dynamic']['toggle']({
                    condition: params['showTail'],
                    true: ',\nkendinizi tanıtmayı unutmayın',
                    false: '',
                }) +
                '\n'
            );
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['participants-sidebar'] = {
        'cloud-recording-in-progress': function (params) {
            return "Yandex Disk'e kayıt yapılıyor";
        },
        'cloud-recording-member-tip': function (params) {
            return 'Bağlantıyı bu toplantının sohbetinde bulabilirsiniz';
        },
        'cloud-recording-member-tip-v2': function (params) {
            return 'Bağlantı bir süre sonra sohbette görünecek. İşlemin tamamlanması zaman alabilir';
        },
        'cloud-recording-owner-tip': function (params) {
            return 'Bağlantıyı bu toplantının sohbetinde ve e-posta kutunuzda bulabilirsiniz';
        },
        'cloud-recording-owner-tip-v2': function (params) {
            return 'Bağlantı bir süre sonra sohbette ve e-postada görünecek. İşlemin tamamlanması zaman alabilir';
        },
        'conference-limit-error-text': function (params) {
            return 'Yeni gelenler bekleme odasına alınıyor';
        },
        'conference-limit-error-title': function (params) {
            return 'Toplantıda yer yok';
        },
        'conference-limit-warning-text': function (params) {
            return 'Bekleyen herkes içeri alınamıyor';
        },
        'conference-limit-warning-title': function (params) {
            return (
                'Toplantıya en fazla ' +
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'katılımcı',
                    some: 'katılımcı',
                    many: 'katılımcı',
                }) +
                ' katılabilir'
            );
        },
        'participants-search-stub-text': function (params) {
            return 'Yanlış yazmadığınızdan emin olun';
        },
        'participants-search-stub-title': function (params) {
            return 'Böyle bir katılımcı yok';
        },
        'peers-tab-conference': function (params) {
            return 'Toplantıda';
        },
        'peers-tab-waiting-room': function (params) {
            return 'Bekleyenler';
        },
        'waiting-room-sort-alfa': function (params) {
            return 'Alfabetik sıra ile';
        },
        'waiting-room-sort-time': function (params) {
            return 'Giriş sırasına göre';
        },
        'waiting-room-stub-text': function (params) {
            return 'Burada, içeri alınmayı bekleyen katılımcılar bulunacak';
        },
        'waiting-room-stub-title': function (params) {
            return 'Bekleme odası boş';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['permission-help'] = {
        header: function (params) {
            return "macOS ayarlarında Yandex Disk'in ekran kaydı \n yapmasına izin verin";
        },
        message: function (params) {
            return "Güvenlik ve Gizlilik > Ekran Kaydı yolunu izleyin ve sağdaki listede Yandex Disk'i işaretleyin";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['plan-call'] = {
        calendar: function (params) {
            return 'Takvim';
        },
        'closed-meeting': function (params) {
            return "Bu özel bir toplantı. Sizi Yandex Takvim'deki katılımcı listesine eklemesi için toplantıyı organize edene başvurun.";
        },
        'error-planned-broadcast': function (params) {
            return 'Yayın planlanamadı';
        },
        'error-planned-call': function (params) {
            return 'Toplantı planlanamadı';
        },
        'go-to-event': function (params) {
            return 'Görüntüle';
        },
        'success-planned-broadcast': function (params) {
            return "Yayın, Yandex Takvim'de planlandı Yayın başlamadan önce tüm katılımcılar bir hatırlatma alır. İzleyicilere ayrıca manuel olarak toplantı bağlantısını gönderin.";
        },
        'success-planned-call': function (params) {
            return "Toplantı, Takvim'e kaydedildi. \nToplantı başlamadan önce tüm katılımcılara \nbir hatırlatma mesajı gönderilecektir.";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['promo'] = {
        'link-preview': function (params) {
            return 'Sohbet ve süre kısıtlaması olmayan görüntülü arama özellikleriyle mesajlaşma';
        },
        'mac-app': function (params) {
            return 'macOS için Telemost';
        },
        'promo-mac-app': function (params) {
            return "macOS için Telemost'u deneyin";
        },
        'promo-win-app': function (params) {
            return "Windows için\nTelemost'u deneyin";
        },
        'win-app': function (params) {
            return 'Windows için Telemost';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['record'] = {
        'file-name-postfix-chat': function (params) {
            return 'sohbet';
        },
        'file-name-postfix-record': function (params) {
            return 'kayıt';
        },
        'file-name-prefix': function (params) {
            return 'Toplantı kaydı';
        },
        'general-record-error': function (params) {
            return 'Запис зупинено. Під час запису сталася помилка.';
        },
        'last-record-download': function (params) {
            return 'Kaydı indir';
        },
        'last-record-download-hint': function (params) {
            return params['date'] + 'tarihindeki toplantının kaydını indir';
        },
        'notify-save-chat-history-cancel-button': function (params) {
            return 'İptal';
        },
        'notify-save-chat-history-save-button': function (params) {
            return 'Kaydet';
        },
        'notify-save-chat-history-text': function (params) {
            return 'Toplantıdaki sohbetin tüm mesajlarını kaydedilsin mi?';
        },
        'quota-exceed-error': function (params) {
            return 'Bilgisayarda boş alan kalmadı. Kayıt durduruldu ve kaydedildi.';
        },
        'some-participants-recording': function (params) {
            return 'Birden fazla katılımcı bilgisayara kayıt yapıyor';
        },
        'somebody-recording': function (params) {
            return params['name'] + ' toplantıyı bilgisayara kaydediyor';
        },
        'waiting-download': function (params) {
            return 'Lütfen bekleyin. Toplantı kaydının indirilmesi başlamak üzere.';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['room-agent'] = {
        'alone-screen-text-first-line': function (params) {
            return '';
        },
        'alone-screen-text-second-line': function (params) {
            return '';
        },
        'alone-screen-title-first-line': function (params) {
            return '';
        },
        'alone-screen-title-second-line': function (params) {
            return '';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings-v2'] = {
        'account-edit': function (params) {
            return 'Düzenle';
        },
        'account-log-in': function (params) {
            return 'Giriş yap';
        },
        'account-stub-title': function (params) {
            return 'Yandex ID ile giriş yap';
        },
        'additional-settings-title': function (params) {
            return 'Gelişmiş';
        },
        'bandwidth-effective-4k-codec-badge': function (params) {
            return 'Deneysel';
        },
        'bandwidth-effective-4k-codec-label': function (params) {
            return 'Ekran paylaşımında trafik optimizasyonu';
        },
        'camera-option-back': function (params) {
            return 'Arka kamera';
        },
        'camera-option-front': function (params) {
            return 'Ön kamera';
        },
        'default-speaker-device': function (params) {
            return 'Default speaker';
        },
        'develop-do-not-check-desktop-app-existence': function (params) {
            return 'Yazılımın kullanılabilirliğini kontrol etme';
        },
        'device-is-not-connected': function (params) {
            return 'Bağlanmadı';
        },
        'diagnostic-access-device-btn': function (params) {
            return 'Nasıl erişim verilir';
        },
        'diagnostic-access-granting-hint': function (params) {
            return 'Bilgisayar ve tarayıcı ayarlarında erişim izni verin';
        },
        'diagnostic-device-permission-denied': function (params) {
            return 'Erişim yok';
        },
        'diagnostic-input-recording-btn': function (params) {
            return 'Kaydediliyor...';
        },
        'diagnostic-input-start-tooltip': function (params) {
            return '5 saniyesi kaydedilecek \nve hemen oynatılacak';
        },
        'diagnostic-output-start-tooltip': function (params) {
            return 'Ses çalmaya başlayacak';
        },
        'diagnostic-play-btn': function (params) {
            return 'Kontrol et';
        },
        'diagnostic-playing-melody': function (params) {
            return 'Ses çalıyor';
        },
        'diagnostic-playing-record': function (params) {
            return 'Kayıt oynatılıyor';
        },
        'diagnostic-record-btn': function (params) {
            return 'Kontrol et';
        },
        'diagnostic-stop-playing-btn': function (params) {
            return 'Durdur';
        },
        'diagnostic-stop-record-btn': function (params) {
            return 'Durdur';
        },
        'diagnostics-bitrate': function (params) {
            return 'Bit hızı';
        },
        'diagnostics-cpu': function (params) {
            return 'CPU';
        },
        'diagnostics-mos': function (params) {
            return 'MOS';
        },
        'diagnostics-packets-lost': function (params) {
            return 'Kayıp paketler';
        },
        'diagnostics-rtt': function (params) {
            return 'RTT';
        },
        'feedback-form-description-placeholder': function (params) {
            return 'Olanları ayrıntılı bir şekilde anlatın';
        },
        'feedback-form-mail-error': function (params) {
            return 'Yazım hatası olmadığından emin olun';
        },
        'feedback-form-mail-placeholder': function (params) {
            return 'E-posta adresi';
        },
        'feedback-form-submit': function (params) {
            return 'Gönder';
        },
        'hide-participants-video-description': function (params) {
            return 'Ağ üzerindeki yükü azaltır';
        },
        'hide-participants-video-label': function (params) {
            return 'Katılımcıların videolarını gizle';
        },
        'kilobits-short': function (params) {
            return 'kbps';
        },
        'matrix-info-could-not-load': function (params) {
            return '';
        },
        'meeting-summarization': function (params) {
            return 'Toplantı özeti';
        },
        'meeting-summarization-v2': function (params) {
            return 'Alisa Pro özeti';
        },
        'menu-item-account': function (params) {
            return 'Hesap';
        },
        'menu-item-develop': function (params) {
            return 'Geliştirme';
        },
        'menu-item-diagnostics': function (params) {
            return 'Tanı';
        },
        'menu-item-help': function (params) {
            return 'Yardım ve destek';
        },
        'menu-item-permissions': function (params) {
            return 'Katılımcıların yetkileri';
        },
        'menu-item-sound': function (params) {
            return 'Ses';
        },
        'menu-item-theme': function (params) {
            return 'Görünüm';
        },
        'menu-item-video': function (params) {
            return 'Video';
        },
        'menu-item-virtual-background': function (params) {
            return 'Toplantı arka planı';
        },
        'milliseconds-short': function (params) {
            return 'ms';
        },
        'mos-quality-excellent': function (params) {
            return 'Mükemmel';
        },
        'mos-quality-good': function (params) {
            return 'İyi';
        },
        'mos-quality-poor': function (params) {
            return 'Kötü';
        },
        'permission-ban-cloud-recording': function (params) {
            return "Toplantıyı Yandex Disk'e kaydet";
        },
        'permission-ban-recording': function (params) {
            return 'Toplantıyı bilgisayara kaydet';
        },
        'permission-ban-summarization': function (params) {
            return 'YandexGPT toplantı notlarını tutsun';
        },
        'permission-ban-summarization-v2': function (params) {
            return "Toplantı notu tutmak için Alisa Pro'yu çalıştır";
        },
        'permissions-description': function (params) {
            return 'Eş düzenleyenler tüm özellikleri kullanabilir';
        },
        'permissions-description-v2': function (params) {
            return 'Eş organizatör yetkilerini kurum yöneticisi ayarlar';
        },
        'permissions-extended-apply': function (params) {
            return '';
        },
        'permissions-extended-by-default': function (params) {
            return '';
        },
        'permissions-extended-by-default-return': function (params) {
            return '';
        },
        'permissions-extended-cancel': function (params) {
            return '';
        },
        'permissions-extended-header': function (params) {
            return '';
        },
        'permissions-extended-reset-modal-cancel': function (params) {
            return '';
        },
        'permissions-extended-reset-modal-confirm': function (params) {
            return '';
        },
        'permissions-extended-reset-modal-description': function (params) {
            return '';
        },
        'permissions-extended-reset-title': function (params) {
            return '';
        },
        'permissions-extended-return-to-default-modal-cancel': function (params) {
            return '';
        },
        'permissions-extended-return-to-default-modal-confirm': function (params) {
            return '';
        },
        'permissions-extended-return-to-default-modal-description': function (params) {
            return '';
        },
        'permissions-extended-return-to-default-modal-title': function (params) {
            return '';
        },
        'permissions-group-camera': function (params) {
            return '';
        },
        'permissions-group-close-room': function (params) {
            return '';
        },
        'permissions-group-cloud-recording': function (params) {
            return '';
        },
        'permissions-group-conference-permissions': function (params) {
            return '';
        },
        'permissions-group-desktop': function (params) {
            return '';
        },
        'permissions-group-microphone': function (params) {
            return '';
        },
        'permissions-group-recording': function (params) {
            return '';
        },
        'permissions-group-summarization': function (params) {
            return '';
        },
        'permissions-group-summarization-v2': function (params) {
            return 'Alisa Pro özeti';
        },
        'permissions-group-waiting-room': function (params) {
            return '';
        },
        'permissions-header': function (params) {
            return 'Katılımcıların bu toplantı için yetkileri';
        },
        'receive-calendar-summary-on-mail': function (params) {
            return "Yandex Takvim'de davetliyseniz özeti e-posta adresinize alın";
        },
        'receive-summary-on-mail': function (params) {
            return 'Toplantı özetini e-posta olarak al';
        },
        'receive-summary-on-mail-v2': function (params) {
            return 'Notlar alınırken toplantıdaysanız özeti e-posta adresinize alın';
        },
        'reload-matrix': function (params) {
            return '';
        },
        'role-permission-access-level-edit': function (params) {
            return '';
        },
        'role-permission-admit': function (params) {
            return '';
        },
        'role-permission-calendar-summarization-receive': function (params) {
            return '';
        },
        'role-permission-camera': function (params) {
            return '';
        },
        'role-permission-camera-ban': function (params) {
            return '';
        },
        'role-permission-camera-mute': function (params) {
            return '';
        },
        'role-permission-camera-unban-self': function (params) {
            return '';
        },
        'role-permission-close-room': function (params) {
            return '';
        },
        'role-permission-cloud-recording': function (params) {
            return '';
        },
        'role-permission-conference-permissions-edit-matrix': function (params) {
            return '';
        },
        'role-permission-desktop': function (params) {
            return '';
        },
        'role-permission-desktop-mute': function (params) {
            return '';
        },
        'role-permission-desktop-override': function (params) {
            return '';
        },
        'role-permission-desktop-unban-self': function (params) {
            return '';
        },
        'role-permission-microphone': function (params) {
            return '';
        },
        'role-permission-microphone-ban': function (params) {
            return '';
        },
        'role-permission-microphone-mute': function (params) {
            return '';
        },
        'role-permission-microphone-unban-self': function (params) {
            return '';
        },
        'role-permission-recording': function (params) {
            return '';
        },
        'role-permission-recording-mute': function (params) {
            return '';
        },
        'role-permission-recording-mute-all': function (params) {
            return '';
        },
        'role-permission-recording-recording-unban-self': function (params) {
            return '';
        },
        'role-permission-summarization': function (params) {
            return 'Not almayı başlat ve durdur';
        },
        'role-permission-summarization-receive': function (params) {
            return '';
        },
        'role-tab-admin': function (params) {
            return '';
        },
        'role-tab-member': function (params) {
            return '';
        },
        'section-account-title': function (params) {
            return 'Hesap';
        },
        'section-develop-title': function (params) {
            return 'Geliştirme';
        },
        'section-diagnostics-subtitle': function (params) {
            return 'Burada bağlantı kalitesi görüntülenir';
        },
        'section-diagnostics-title': function (params) {
            return 'Tanı';
        },
        'section-help-title': function (params) {
            return 'Yardım ve destek';
        },
        'section-permissions-extended-title': function (params) {
            return '';
        },
        'section-sound-title': function (params) {
            return 'Ses';
        },
        'section-theme-subtitle': function (params) {
            return "Bu arka plan Telemost'ta, Yandex Mail'de ve Disk'te kullanılacak";
        },
        'section-theme-title': function (params) {
            return 'Yandex 360 tasarım teması';
        },
        'sound-change-not-supported-title': function (params) {
            return 'Bu tarayıcıda ses ayarlanamaz';
        },
        'sound-join-with-microphone-off': function (params) {
            return 'Mikrofon kapalı olarak bağlan';
        },
        'sound-microphone': function (params) {
            return 'Mikrofon';
        },
        'sound-noise-cancellation': function (params) {
            return 'Gürültü önleme';
        },
        'sound-noise-cancellation-auto': function (params) {
            return 'Otomatik';
        },
        'sound-noise-cancellation-auto-description': function (params) {
            return 'Gürültü seviyesine göre ayarlanır';
        },
        'sound-noise-cancellation-auto-description-v2': function (params) {
            return 'Düşük veya yüksek. Bilgisayarın yüküne uyum sağlar';
        },
        'sound-noise-cancellation-auto-v2': function (params) {
            return 'Adaptif';
        },
        'sound-noise-cancellation-disabled': function (params) {
            return 'Kapalı';
        },
        'sound-noise-cancellation-high': function (params) {
            return 'Yüksek';
        },
        'sound-noise-cancellation-high-description': function (params) {
            return 'Kafe veya sokak gürültüsü';
        },
        'sound-noise-cancellation-high-description-v2': function (params) {
            return 'Tüm gürültüyü ortadan kaldırır. Bilgisayarın hızını yavaşlatabilir';
        },
        'sound-noise-cancellation-low': function (params) {
            return 'Düşük';
        },
        'sound-noise-cancellation-low-description': function (params) {
            return 'Tuş sesi, kağıt hışırtısı';
        },
        'sound-noise-cancellation-low-description-v2': function (params) {
            return 'Hafif gürültüyü ortadan kaldırır';
        },
        'sound-speaker': function (params) {
            return 'Hoparlör';
        },
        'support-help-go-to': function (params) {
            return 'Git';
        },
        'support-help-title': function (params) {
            return 'Yardım';
        },
        'support-report-problem': function (params) {
            return 'Yaz';
        },
        'support-title': function (params) {
            return 'Destek Ekibi';
        },
        title: function (params) {
            return 'Ayarlar';
        },
        'unsupported-browser-subtitle': function (params) {
            return (
                '<x-link-telemost>' +
                "Bilgisayar için Telemost'u" +
                '</x-link-telemost>' +
                ' yükleyin veya ' +
                '<x-link-yabro>' +
                "Yandex Browser'ı" +
                '</x-link-yabro>' +
                ' deneyin'
            );
        },
        'video-background-tumbler-label': function (params) {
            return 'Dinamik arka plan';
        },
        'video-camera': function (params) {
            return 'Kamera';
        },
        'video-change-not-supported-description': function (params) {
            return (
                '<x-link-telemost>' +
                "Bilgisayar için Telemost'u" +
                '</x-link-telemost>' +
                ' yükleyin veya ' +
                '<x-link-yabro>' +
                "Yandex Browser'ı" +
                '</x-link-yabro>' +
                ' deneyin'
            );
        },
        'video-change-not-supported-title': function (params) {
            return 'Bu tarayıcıda kamera ayarlanamaz';
        },
        'video-join-with-camera-off': function (params) {
            return 'Kamera kapalı olarak bağlan';
        },
        'video-show-me': function (params) {
            return 'Toplantıda kendini gör';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['settings'] = {
        account: function (params) {
            return 'Hesap';
        },
        camera: function (params) {
            return 'Kamera';
        },
        'camera-background-blurred': function (params) {
            return 'Bulanık';
        },
        'camera-background-none': function (params) {
            return 'Arka\nplan yok';
        },
        'camera-option-back': function (params) {
            return 'Arka kamera';
        },
        'camera-option-front': function (params) {
            return 'Ön kamera';
        },
        'change-avatar': function (params) {
            return 'Avatarı değiştir';
        },
        'change-name-and-avatar': function (params) {
            return 'Adı ve avatarı değiştir';
        },
        'disclaimer-before-connection': function (params) {
            return 'Bağlantıyla ilgili uyarı';
        },
        'do-not-check-desktop-app-existence': function (params) {
            return 'Yazılımın kullanılabilirliğini kontrol etme';
        },
        'help-and-support': function (params) {
            return 'Yardım ve Destek';
        },
        'hide-participants-video': function (params) {
            return 'Katılımcıların videolarını gizle';
        },
        'hide-participants-video-description': function (params) {
            return 'Bağlantı üzerindeki yükü azaltır';
        },
        'join-with-camera-off': function (params) {
            return 'Kamera kapalı olarak bağlan';
        },
        'join-with-microphone-off': function (params) {
            return 'Mikrofon kapalı olarak bağlan';
        },
        login: function (params) {
            return 'Hesaba giriş yap';
        },
        logout: function (params) {
            return 'Hesaptan çık';
        },
        mic: function (params) {
            return 'Mikrofon';
        },
        'no-theme': function (params) {
            return 'Temasız';
        },
        'noise-cancellation-auto': function (params) {
            return 'Otomatik';
        },
        'noise-cancellation-auto-v2': function (params) {
            return 'Adaptif';
        },
        'noise-cancellation-high': function (params) {
            return 'Güçlü';
        },
        'noise-cancellation-low': function (params) {
            return 'Hafif';
        },
        'noise-cancellation-title': function (params) {
            return 'Gürültü engelleme';
        },
        'only-beta-testers': function (params) {
            return 'Sadece beta test katılımcıları';
        },
        'permission-ban-cloud-recording': function (params) {
            return "Toplantıyı Yandex Disk'e kaydet";
        },
        'permission-ban-recording': function (params) {
            return 'Toplantıyı bilgisayara kaydet';
        },
        'permission-ban-summarization': function (params) {
            return "Toplantı notları almak için YandexGPT'yi çalıştır";
        },
        'permissions-explanation': function (params) {
            return 'Eş düzenleyenler her zaman tüm özellikleri kullanabilir';
        },
        'permissions-header': function (params) {
            return 'Katılımcıların bu toplantı için yetkileri';
        },
        'permissions-members': function (params) {
            return 'Katılımcı yetkileri';
        },
        'receive-summary-on-mail': function (params) {
            return 'Toplantı özetini e-posta olarak al';
        },
        'same-as-system': function (params) {
            return 'Sistem ayarını kullan';
        },
        security: function (params) {
            return 'Güvenlik';
        },
        'show-mic-or-camera-on': function (params) {
            return 'Kamera ve mikrofonun açık olup olmadığını göster';
        },
        'show-my-video': function (params) {
            return 'Toplantı sırasında kendi görüntümü göster';
        },
        sound: function (params) {
            return 'Ses';
        },
        'sound-output': function (params) {
            return 'Ses çıkışı';
        },
        support: function (params) {
            return 'Destek';
        },
        theme: function (params) {
            return 'Tasarım teması';
        },
        'theme-dark-flow': function (params) {
            return 'Karanlık akış';
        },
        'theme-flow': function (params) {
            return 'Akış';
        },
        'theme-grass': function (params) {
            return 'Çim';
        },
        'theme-new-year': function (params) {
            return 'Yeni yıl';
        },
        'theme-title': function (params) {
            return 'Yandex 360 tasarım teması';
        },
        title: function (params) {
            return 'Ayarlar';
        },
        'unsupported-camera-change-message': function (params) {
            return (
                "Mozilla Firefox'ta kamera ayarları değiştirilemez. " +
                '<x-link-telemost>' +
                'Bilgisayar için Telemost' +
                '</x-link-telemost>' +
                ' veya ' +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                "'ı deneyin."
            );
        },
        'unsupported-microphone-change-message': function (params) {
            return (
                "Mozilla Firefox'ta kamera ayarları değiştirilemez.\n" +
                '<x-link-telemost>' +
                'Bilgisayar için Telemost' +
                '</x-link-telemost>' +
                "'u veya " +
                '<x-link-yabro>' +
                'Yandex Browser' +
                '</x-link-yabro>' +
                "'ı deneyin."
            );
        },
        'virtual-background': function (params) {
            return 'Sanal arka plan';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['share-screen'] = {
        'full-screen': function (params) {
            return 'Tam ekran';
        },
        'please-wait-long': function (params) {
            return 'Lütfen bekleyin. Kısa süre içerisinde hazır olacak';
        },
        screen: function (params) {
            return 'Ekran';
        },
        'self-starts-demonstration': function (params) {
            return 'Ekran paylaşımı başlatıyorsunuz';
        },
        'start-demonstration': function (params) {
            return 'Ekran paylaşımını başlat';
        },
        'start-sharing': function (params) {
            return 'Ekran yayınını başlat';
        },
        'stop-demonstration': function (params) {
            return 'Ekran paylaşımını bitir';
        },
        'stop-demonstration-2': function (params) {
            return 'Ekran paylaşımını durdur';
        },
        'user-starts-demonstration': function (params) {
            return params['name'] + ' ekran paylaşımını başlatıyor';
        },
        window: function (params) {
            return 'Program penceresi';
        },
        'your-screen-shared': function (params) {
            return 'Toplantının diğer katılımcıları ekranınızı görebiliyor';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['statuses'] = {
        'admins-will-receive-summary': function (params) {
            return 'Toplantı özeti, eş düzenleyenlere e-posta olarak gönderilecek';
        },
        'admins-will-receive-summary-update-error': function (params) {
            return 'Ayarlar değiştirilemedi, özet eş düzenleyenlere gönderilecek';
        },
        'broadcast-create-error': function (params) {
            return 'Yayın oluşturulamadı';
        },
        'broadcast-end-error': function (params) {
            return 'Yayın sonlandırılamadı';
        },
        'broadcast-start-error': function (params) {
            return 'Yayın başlatılamadı';
        },
        'broadcast-stop-error': function (params) {
            return 'Yayın durdurulamadı';
        },
        'camera-error': function (params) {
            return 'Video etkinleştirilemedi.\nKamera çalışmıyor veya başka bir uygulama tarafından kullanılıyor.';
        },
        'camera-permission-denied': function (params) {
            return 'Video etkinleştirilemedi.\nKameraya erişim yok.';
        },
        'chat-create-error': function (params) {
            return 'Görüntülü toplantı oluşturulamadı,' + params['spacebreak'] + 'daha sonra deneyin';
        },
        'chat-open-error': function (params) {
            return 'Görüntülü toplantı açılamadı,' + params['spacebreak'] + 'daha sonra deneyin';
        },
        'connection-established': function (params) {
            return 'Tekrar toplatıya katıldınız';
        },
        'feedback-sended': function (params) {
            return 'Gelişmemize yardımcı olduğunuz için teşekkürler!';
        },
        'how-to-do-it': function (params) {
            return 'Nasıl yapılır?';
        },
        'how-to-enable-device': function (params) {
            return 'Erişim izni nasıl verilir?';
        },
        joining: function (params) {
            return 'Bağlanılıyor';
        },
        'link-already-copied': function (params) {
            return 'Toplantı bağlantısı \n panoya kopyalanmış durumda';
        },
        'link-copied': function (params) {
            return 'Bağlantı panoya kopyalandı';
        },
        'microphone-error': function (params) {
            return 'Mikrofon çalıştırılamadı.\nMikrofon çalışmıyor veya başka bir uygulama tarafından kullanılıyor.';
        },
        'microphone-permission-denied': function (params) {
            return 'Mikrofon çalıştırılamadı.\nMikrofona erişim yok.';
        },
        'modal-device-error-text-audioinput': function (params) {
            return 'Mikrofonun bağlı olduğundan ve Telemost ayarlarında seçili olduğundan emin olun ';
        },
        'modal-device-error-text-audioinput-busy': function (params) {
            return 'Sesi açmak için bu uygulamayı kapatın veya ayarlardan farklı bir mikrofon seçin';
        },
        'modal-device-error-text-audioinput-denied-by-system': function (params) {
            return 'İşletim sistemi ayarlarından ve ardından tarayıcının adres çubuğundan mikrofona erişim izni verin';
        },
        'modal-device-error-text-audioinput-denied-by-user': function (params) {
            return 'Mikrofona erişim izni verin';
        },
        'modal-device-error-text-audioinput-denied-by-user-alternative': function (params) {
            return 'Tarayıcının adres çubuğunda mikrofon simgesine ve ardından "İzin ver" seçeneğine tıklayın';
        },
        'modal-device-error-text-not-ready': function (params) {
            return 'Telemost ayarlarından başka bir cihaz seçin veya bilgisayarınızı yeniden başlatın ve tekrar bağlayın';
        },
        'modal-device-error-text-request': function (params) {
            return 'Cihazların bağlı ve Telemost ayarlarında seçili olduğundan, ayrıca herhangi başka bir uygulama tarafından kullanılmadıklarından ve bunlara erişim izni verildiğinden emin olun';
        },
        'modal-device-error-text-request-alternative': function (params) {
            return 'Kameranın bağlı ve Telemost ayarlarında seçili olduğundan ve herhangi başka bir uygulama tarafından kullanılmadığından emin olun. Tarayıcının adres çubuğunda mikrofon simgesine ve ardından "İzin ver" seçeneğine tıklayın';
        },
        'modal-device-error-text-videoinput': function (params) {
            return 'Kameranın bağlı olduğundan ve Telemost ayarlarında seçili olduğundan emin olun';
        },
        'modal-device-error-text-videoinput-applying': function (params) {
            return 'Kameranın bağlı ve Telemost ayarlarında seçili olduğundan, ayrıca herhangi başka bir uygulama tarafından kullanılmadığından ve kendisine erişim izni verildiğinden emin olun';
        },
        'modal-device-error-text-videoinput-applying-alternative': function (params) {
            return 'Kameranın bağlı ve Telemost ayarlarında seçili olduğundan ve herhangi başka bir uygulama tarafından kullanılmadığından emin olun. Tarayıcının adres çubuğunda mikrofon simgesine ve ardından "İzin ver" seçeneğine tıklayın';
        },
        'modal-device-error-text-videoinput-busy': function (params) {
            return 'Videoyu açmak için bu uygulamayı kapatın veya ayarlardan farklı bir kamera seçin';
        },
        'modal-device-error-text-videoinput-denied-by-system': function (params) {
            return 'İşletim sistemi ayarlarından ve ardından tarayıcının adres çubuğundan kameraya erişim izni verin';
        },
        'modal-device-error-text-videoinput-denied-by-user': function (params) {
            return 'Kameraya erişim izni verin';
        },
        'modal-device-error-text-videoinput-denied-by-user-alternative': function (params) {
            return 'Tarayıcının adres çubuğunda mikrofon simgesine ve ardından "İzin ver" seçeneğine tıklayın';
        },
        'modal-device-error-text-videoinput-overconstrained': function (params) {
            return 'Kamera optimum çözünürlüğü desteklemiyor. Ayarlardan değiştirin veya videoyu devre dışı bırakın';
        },
        'modal-device-error-title-audioinput': function (params) {
            return 'Mikrofon etkinleştirilemedi';
        },
        'modal-device-error-title-audioinput-busy': function (params) {
            return 'Mikrofon başka bir uygulama tarafından kullanılıyor';
        },
        'modal-device-error-title-audioinput-sound': function (params) {
            return 'Ses açılamadı';
        },
        'modal-device-error-title-not-ready': function (params) {
            return 'Video veya mikrofon etkinleştirilemedi';
        },
        'modal-device-error-title-request': function (params) {
            return 'Video veya mikrofon etkinleştirilemedi';
        },
        'modal-device-error-title-videoinput': function (params) {
            return 'Video etkinleştirilemedi';
        },
        'modal-device-error-title-videoinput-busy': function (params) {
            return 'Kamera başka bir uygulama tarafından kullanılıyor';
        },
        'modal-device-error-title-videoinput-overconstrained': function (params) {
            return 'Görüntünüzün kalitesi düşük';
        },
        'network-quality-bad': function (params) {
            return 'Bağlantınız zayıf';
        },
        'network-quality-hide-video': function (params) {
            return 'Katılımcıların videoları gizlenirse ses kalitesi daha yüksek olur';
        },
        'network-quality-show-video': function (params) {
            return 'Bağlantı kuruldu, katılımcıların videolarını tekrar açabilirsiniz';
        },
        'no-internet': function (params) {
            return 'İnternet bağlantısı yok';
        },
        'no-permission-to-close-room': function (params) {
            return '';
        },
        'notification-broadcast-access-level-organization': function (params) {
            return 'Yayın yalnızca kurum çalışanlarına açık';
        },
        'notification-broadcast-access-level-public': function (params) {
            return 'Yayın harici kullanıcılara açık';
        },
        'notification-cloud-recording-in-progress': function (params) {
            return "Toplantı Yandex Disk'e kaydediliyor";
        },
        'notification-cloud-recording-start-failed': function (params) {
            return "Yandex Disk'e kayda başlanamadı";
        },
        'notification-cloud-recording-start-failed-mobile': function (params) {
            return 'Kayda başlanamadı';
        },
        'notification-cloud-recording-stop-failed': function (params) {
            return "Yandex Disk'e kayıt durdurulamadı";
        },
        'notification-cloud-recording-stop-failed-mobile': function (params) {
            return 'Kayıt durdurulamadı';
        },
        'notification-cloud-recording-was-stopped': function (params) {
            return "Yandex Disk'e kayıt durduruldu";
        },
        'notification-conference-access-level-organization': function (params) {
            return 'Toplantı yalnızca kurum çalışanlarına açık';
        },
        'notification-conference-access-level-public': function (params) {
            return 'Toplantı harici kullanıcılara açık';
        },
        'notification-conference-access-level-waiting-room-admins': function (params) {
            return 'Bekleme odası herkes için etkin';
        },
        'notification-conference-access-level-waiting-room-organization': function (params) {
            return 'Bekleme odası harici katılımcılar için etkin';
        },
        'notification-conference-access-level-waiting-room-public': function (params) {
            return 'Bekleme odası devre dışı';
        },
        'notification-noise-cancellation-disabled': function (params) {
            return 'Gürültü engelleme devre dışı';
        },
        'notification-noise-cancellation-enabled': function (params) {
            return 'Gürültü engelleme etkin';
        },
        'notification-noise-cancellation-high': function (params) {
            return 'Güçlü gürültü engelleme etkin';
        },
        'notification-noise-cancellation-low': function (params) {
            return 'Hafif gürültü engelleme etkin';
        },
        'notification-summarization-in-progress-for-external': function (params) {
            return 'Toplantı kaydediliyor';
        },
        'notification-summarization-in-progress-v2': function (params) {
            return 'Toplantı notları tutuluyor';
        },
        'notification-summarization-no-permission-to-stop': function (params) {
            return '';
        },
        'notification-summarization-start-failed-v2': function (params) {
            return 'Not alma başlatılamadı';
        },
        'notification-summarization-stop-failed-v2': function (params) {
            return 'Not alma durdurulamadı';
        },
        'notification-summarization-was-stopped': function (params) {
            return 'Toplantı notları tutulmuyor';
        },
        'open-settings': function (params) {
            return 'Ayarlara git';
        },
        'organizer-revoked-camera-permission': function (params) {
            return '';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return '';
        },
        'organizer-revoked-micro-permission': function (params) {
            return '';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return '';
        },
        'participants-limit': function (params) {
            return 'Görüntülü toplantıya bağlanılamıyor: Katılımcı limitine ulaşıldı';
        },
        'participants-video-hidden': function (params) {
            return 'Katılımcıların videoları gizlendi';
        },
        'participants-video-visible': function (params) {
            return 'Katılımcıların videoları gösteriliyor';
        },
        'participants-will-receive-summary': function (params) {
            return 'Toplantı özeti, tüm katılımcıların e-postasına gönderilecek';
        },
        'participants-will-receive-summary-update-error': function (params) {
            return 'Ayarlar değiştirilemedi, özet tüm katılımcılara gönderilecek';
        },
        'permissions-extended-apply-error': function (params) {
            return '';
        },
        'permissions-extended-apply-success': function (params) {
            return '';
        },
        'permissions-extended-matrix-edit-revoked': function (params) {
            return '';
        },
        'please-unmute': function (params) {
            return 'Sizi duyamıyorlar, mikrofonu etkinleştirin';
        },
        reconnecting: function (params) {
            return 'Hata oluştu; tekrar bağlanmayı deniyoruz';
        },
        'restoring-connection': function (params) {
            return 'Tekrar bağlantı kuruluyor';
        },
        'room-was-closed': function (params) {
            return 'Toplantıyı düzenleyen kişi toplantıyı herkes için sonlandırdı';
        },
        'screen-sharing-access-message': function (params) {
            return 'Tarayıcı ayarlarında ekrana erişim izni verin';
        },
        'screen-sharing-already-active': function (params) {
            return 'Ekran paylaşımı aktif. ';
        },
        'screen-sharing-cancelled-or-denied-message': function (params) {
            return 'Kızlar kon. olarak bas dünyayıat tek edildiğinde ardından';
        },
        'screen-sharing-error-info-message': function (params) {
            return 'Yenisini başlatmak için mevcut paylaşımı sonlandırın.';
        },
        'screen-sharing-race-message': function (params) {
            return 'Başka bir kullanıcı sizinle birlikte ekran yayınlamaya başladı. Lütfen, ekran yayınını daha sonra başlatmayı deneyin.';
        },
        'summarization-in-progress-admins-will-receive': function (params) {
            return 'Toplantı notları tutuluyor. Sonuç, eş düzenleyenlere e-posta olarak gönderilecek';
        },
        'summarization-in-progress-participants-will-receive': function (params) {
            return 'Toplantı notları tutuluyor. Sonuç, tüm katılımcılara e-posta olarak gönderilecek';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Not almayı eş düzenleyen başlatabilir';
        },
        'to-settings': function (params) {
            return 'Ayarlara git';
        },
        'turn-on': function (params) {
            return 'Etkinleştir';
        },
        'user-broadcasting': function (params) {
            return params['name'] + ' toplantı\nkaydını tutuyor';
        },
        'user-was-kicked': function (params) {
            return 'Toplantıdan çıkarıldınız';
        },
        'video-loading': function (params) {
            return 'Videoyu yükleniyor';
        },
        'waiting-room-admit-all-error': function (params) {
            return 'Bekleme odasındaki katılımcılar içeri alınamadı';
        },
        'waiting-room-admit-error': function (params) {
            return 'Katılımcı içeri alınamadı';
        },
        'waiting-room-new-peer': function (params) {
            return params['displayName'] + ' bekleme odasında';
        },
        'waiting-room-new-peers': function (params) {
            return 'Katılımcılar bekleme odasında';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['summarization'] = {
        'feedback-chat-section-description': function (params) {
            return 'Yorumlar bırakın, notların geliştirilmesine yardımcı olun. Güncellemeler hakkında bilgi alın';
        },
        'feedback-chat-section-join': function (params) {
            return 'Sohbete katıl';
        },
        'feedback-chat-section-title': function (params) {
            return 'Geliştirmemize yardımcı olun';
        },
        'feedback-content': function (params) {
            return 'Bu şekilde yapay zeka daha hızlı öğrenir';
        },
        'feedback-content-v2': function (params) {
            return 'Bu şekilde Alisa Pro daha hızlı öğrenir';
        },
        'feedback-header': function (params) {
            return 'Değerlendirmeniz için teşekkür ederiz';
        },
        'send-summary-to-participants': function (params) {
            return 'Tüm katılımcılara özeti gönder';
        },
        'start-dialog-content': function (params) {
            return 'Toplantı özeti, toplantının sohbetine ve YandexGPT çalışırken toplantıda bulunan Yandex katılımcılarının e-postalarına gelecek';
        },
        'start-dialog-content-v2': function (params) {
            return 'O sırada toplantıda bulunan eş düzenleyenler e-posta kutularına toplantı notlarını alırlar';
        },
        'start-dialog-deny': function (params) {
            return 'Hayır';
        },
        'start-dialog-submit': function (params) {
            return 'Evet';
        },
        'start-dialog-title': function (params) {
            return 'YandexGPT toplantı notlarını tutsun mu?';
        },
        'start-dialog-title-v2': function (params) {
            return 'Toplantı notu tutulsun mu?';
        },
        'stop-dialog-change-participants-permissions': function (params) {
            return (
                'Katılımcı yetkilerinde değişiklik yapmak için ' +
                '<x-link-settings>' +
                'ayarlara gidin' +
                '</x-link-settings>'
            );
        },
        'stop-dialog-content': function (params) {
            return 'Toplantının özetlenmesi tüm katılımcılar için durdurulacak';
        },
        'stop-dialog-content-receive-by-mail': function (params) {
            return 'Özet, e-posta adresine gönderilecek';
        },
        'stop-dialog-content-v2': function (params) {
            return 'Not alma herkes için durdurulacak. Özet, eş düzenleyenlere e-posta olarak gönderilecek';
        },
        'stop-dialog-content-v3': function (params) {
            return 'Not alma herkes için durdurulacak.';
        },
        'stop-dialog-content_admins_bsr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_admins_bsr_members_bsr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlerin veya katılımcıların e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_admins_bsr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_admins_bsr_members_sr': function (params) {
            return '— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_admins_csr': function (params) {
            return 'Özet, Yandex Takvim üzerinden davet edilen eş organizatörlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_admins_csr_members_bsr': function (params) {
            return '— Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_admins_csr_members_csr': function (params) {
            return 'Özet, Yandex Takvim üzerinden davet edilen eş organizatörlerin ve katılımcıların e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_admins_csr_members_sr': function (params) {
            return '— Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_admins_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunan eş organizatörlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_admins_sr_members_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunan eş organizatörlere\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_admins_sr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunan eş organizatörlere\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_admins_sr_members_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunan eş organizatörlerin ve katılımcıların e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_members_bsr': function (params) {
            return '— Özet, notlar alınırken toplantıda bulunan veya Yandex Takvim üzeriden davet edilen katılımcıların e-posta adreslerine gönderilecek\n— Özet organizatöre ve eş organizatörlere gönderilemeyecek';
        },
        'stop-dialog-content_members_csr': function (params) {
            return '— Özet, Yandex Takvim üzeriden davet edilen katılımcıların e-posta adreslerine gönderilecek\n— Özet organizatöre ve eş organizatörlere gönderilmeyecek';
        },
        'stop-dialog-content_members_sr': function (params) {
            return '— Özet, notlar alınırken toplantıda bulunan katılımcıların e-posta adreslerine gönderilecek\n— Özet organizatöre ve eş organizatörlere gönderilmeyecek';
        },
        'stop-dialog-content_nobody-receive': function (params) {
            return 'Özet kimseye gönderilmeyecek. Organizatör ve eş organizatör yetkilerinde değişiklik yapmak için kurum yöneticisiyle iletişime geçin';
        },
        'stop-dialog-content_owner_csr': function (params) {
            return 'Özet, organizatörün e-posta adresine gönderilecek';
        },
        'stop-dialog-content_owner_csr_admins_bsr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzeriden davet edilen eş organizatörlere';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_bsr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunanların ve ayrıca Yandex Takvim üzerinden davet edilenlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_csr': function (params) {
            return '— Yandex Takvim üzerinden davet edilen herkese\n— Notlar alınırken toplantıda bulunan eş organizatörlere';
        },
        'stop-dialog-content_owner_csr_admins_bsr_members_sr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_owner_csr_admins_csr': function (params) {
            return 'Özet, organizatörün ve Yandex Takvim üzerinden davet edilen eş organizatörlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_bsr': function (params) {
            return '— Yandex Takvim üzerinden davet edilen herkese\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_csr': function (params) {
            return 'Özet, Yandex Takvim üzerinden davet edilenlerin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_csr_admins_csr_members_sr': function (params) {
            return '— Organizatöre\n— Yandex Takvim üzerinden davet edilen eş organizatörlere\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_owner_csr_admins_sr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan eş organizatörlere';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_bsr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan eş organizatörlere\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_csr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan eş organizatörlere\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_csr_admins_sr_members_sr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan eş organizatörlere ve katılımcılara';
        },
        'stop-dialog-content_owner_csr_members_bsr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzeriden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_csr_members_csr': function (params) {
            return 'Özet, organizatörün ve Yandex Takvim üzerinden davet edilen katılımcıların e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_csr_members_sr': function (params) {
            return '— Organizatöre\n— Notlar alınırken toplantıda bulunan katılımcılara';
        },
        'stop-dialog-content_owner_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunduysa organizatörün e-posta adresine gönderilecek';
        },
        'stop-dialog-content_owner_sr_admins_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunduysa organizatöre\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen eş organizatörlere';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunan herkese\n— Yandex Takvim üzerinden davet edilen eş organizatörlere ve katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunanlara: organizatöre ve eş organizatörlere\n— Yandex Takvim üzerinden davet edilen eş organizatörlere ve katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_bsr_members_sr': function (params) {
            return '— Notlar alınırken toplantıda bulunan herkese\n— Yandex Takvim üzerinden davet edilen eş organizatörlere';
        },
        'stop-dialog-content_owner_sr_admins_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunduysa organizatöre\n— Yandex Takvim üzerinden davet edilen eş organizatörlere';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunanlara: organizatöre ve katılımcılara\n— Yandex Takvim üzerinden davet edilen eş organizatörlere ve katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunduysa organizatöre\n— Yandex Takvim üzerinden davet edilen eş organizatörlere ve katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_csr_members_sr': function (params) {
            return '— Notlar alınırken toplantıda bulunanlara: organizatöre ve katılımcılara\n— Yandex Takvim üzerinden davet edilen eş organizatörlere';
        },
        'stop-dialog-content_owner_sr_admins_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunanların (organizatörün ve eş organizatörlerin) e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunan herkese\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunanlara: organizatöre ve eş organizatörlere\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_sr_admins_sr_members_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunan herkesin e-posta adreslerine gönderilecek';
        },
        'stop-dialog-content_owner_sr_members_bsr': function (params) {
            return '— Notlar alınırken toplantıda bulunduysa organizatöre\n— Notlar alınırken toplantıda bulunan veya Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_sr_members_csr': function (params) {
            return '— Notlar alınırken toplantıda bulunduysa organizatöre\n— Yandex Takvim üzerinden davet edilen katılımcılara';
        },
        'stop-dialog-content_owner_sr_members_sr': function (params) {
            return 'Özet, notlar alınırken toplantıda bulunanların (organizatörün ve katılımcıların) e-posta adreslerine gönderilecek';
        },
        'stop-dialog-deny': function (params) {
            return 'Hayır, devam et';
        },
        'stop-dialog-deny-v2': function (params) {
            return 'Hayır';
        },
        'stop-dialog-submit': function (params) {
            return 'Durdur';
        },
        'stop-dialog-submit-v2': function (params) {
            return 'Evet';
        },
        'stop-dialog-title': function (params) {
            return 'Toplantının özetlenmesi durdurulsun mu?';
        },
        'stop-dialog-title-v2': function (params) {
            return 'Toplantının özetlenmesi durdurulsun mu?';
        },
        'welcome-dialog-content': function (params) {
            return 'Yandex katılımcıları toplantı özetini e-postalarına alacak; harici katılımcılar özeti almayacak';
        },
        'welcome-dialog-content-v2': function (params) {
            return 'Toplantının eş  organizatörleri toplantı notlarını başlatabilir; toplantı özeti ve bunun metin olarak çözümü e-posta kutularına gelir';
        },
        'welcome-dialog-content-v3': function (params) {
            return 'Toplantının tam kaydı, alınan kararlar ve ana konuların özeti e-postada';
        },
        'welcome-dialog-submit': function (params) {
            return 'Harika';
        },
        'welcome-dialog-title': function (params) {
            return 'YandexGPT toplantının özetini hazırlayacak ';
        },
        'welcome-dialog-title-v2': function (params) {
            return 'Yapay zekadan toplantı özeti ';
        },
        'welcome-dialog-title-v3': function (params) {
            return 'Alisa Pro toplantı notlarını tutacak';
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['telemessenger-placeholder'] = {
        'continue-in-browser': function (params) {
            return 'Tarayıcıda devam et';
        },
        'install-telemost': function (params) {
            return "Telemost'u indir";
        },
        'install-telemost-motivation-text': function (params) {
            return 'Mesajlaşmak ve görüntülü aramalar için uygulamayı indirin';
        },
        'you-have-been-invited-to-telemost-chat': function (params) {
            return "Telemost'ta sohbete\ndavet edildiniz";
        },
    };

    /* Это автоматически сгенеренный файл. Не редактируйте его самостоятельно. */
    var i18n = i18n || {};

    i18n['telemost'] = i18n['telemost'] || {};

    i18n['telemost']['toolbar'] = {
        'access-level-organization': function (params) {
            return 'Harici erişime kapat';
        },
        'access-level-public': function (params) {
            return 'Herkesin erişimine aç';
        },
        'broadcast-continue': function (params) {
            return 'Yayına devam et';
        },
        'broadcast-continue-v2': function (params) {
            return 'Yayını yenile';
        },
        'broadcast-copy-link': function (params) {
            return 'İzleyiciler için bağlantı';
        },
        'broadcast-end': function (params) {
            return 'Yayını sonlandır';
        },
        'broadcast-end-confirm-modal-cancel': function (params) {
            return 'İptal';
        },
        'broadcast-end-confirm-modal-confirm': function (params) {
            return 'Sonlandır';
        },
        'broadcast-end-confirm-modal-content': function (params) {
            return 'İzleyiciler toplantıyı artık göremeyecek ve katılımcılar sohbete devam edebilecek';
        },
        'broadcast-end-confirm-modal-header': function (params) {
            return 'Yayın sonlandırılsın mı?';
        },
        'broadcast-ending': function (params) {
            return 'Kapatılıyor...';
        },
        'broadcast-not-on-air': function (params) {
            return 'Yayında değil';
        },
        'broadcast-not-on-air-tooltip': function (params) {
            return 'Yayını başlatmak veya izleyiciler için bağlantıyı kopyalamak için tıklayın';
        },
        'broadcast-on-air': function (params) {
            return 'Yayında';
        },
        'broadcast-on-air-tooltip': function (params) {
            return 'Yayını durdurmak veya izleyiciler için bağlantıyı kopyalamak için tıklayın';
        },
        'broadcast-paused': function (params) {
            return 'Duraklat';
        },
        'broadcast-paused-tooltip': function (params) {
            return 'Yayına devam etmek veya izleyiciler için bağlantıyı kopyalamak için tıklayın';
        },
        'broadcast-starting': function (params) {
            return 'Çalıştırılıyor...';
        },
        'broadcast-starting-tooltip': function (params) {
            return 'Yayın başlatılıyor; bu, bir dakika kadar sürebilir';
        },
        'broadcast-viewers-count': function (params) {
            return (
                'Toplam ' +
                params['count'] +
                ' ' +
                i18n['tanker']['dynamic']['plural']({
                    count: params['count'],
                    one: 'izleyici',
                    some: 'izleyici',
                    many: 'izleyici',
                }) +
                ' var'
            );
        },
        'chat-button-alt-title': function (params) {
            return 'Sohbet aç';
        },
        'chat-button-title': function (params) {
            return 'Sohbet';
        },
        'close-toolbar': function (params) {
            return 'Bölümü kapat';
        },
        'cloud-recording-prepare': function (params) {
            return 'Kayıt için hazırlıklar yapılıyor...';
        },
        'cloud-recording-start': function (params) {
            return "Yandex Disk'e kaydet";
        },
        'cloud-recording-stop': function (params) {
            return "Yandex Disk'e kaydı durdur";
        },
        'continue-broadcast': function (params) {
            return 'Yayına devam et';
        },
        'create-broadcast': function (params) {
            return 'Yayın oluştur';
        },
        'end-call': function (params) {
            return 'Toplantıdan çık';
        },
        'end-call-alt': function (params) {
            return 'Toplantıdan çık';
        },
        'end-call-for-everyone': function (params) {
            return 'Toplantıyı herkes için sonlandır';
        },
        'gallery-view': function (params) {
            return 'Galeri görünümü';
        },
        'hand-down': function (params) {
            return 'Elini indir';
        },
        'hand-up': function (params) {
            return 'Elini kaldır';
        },
        'local-recording-start': function (params) {
            return 'Bilgisayara kaydet';
        },
        'local-recording-stop': function (params) {
            return 'Bilgisayara kaydı durdur';
        },
        'more-option-turn-off-camera': function (params) {
            return 'Videoyu devre dışı bırak';
        },
        'more-option-turn-off-mic': function (params) {
            return 'Mikrofonu devre dışı bırak';
        },
        'more-option-turn-on-camera': function (params) {
            return 'Videoyu etkinleştir';
        },
        'more-popup-alt-title': function (params) {
            return 'Daha fazla';
        },
        'more-popup-option-settings': function (params) {
            return 'Ayarlar';
        },
        'open-settings': function (params) {
            return 'Ayarları aç';
        },
        'organizer-revoked-camera-permission': function (params) {
            return '';
        },
        'organizer-revoked-desktop-permission': function (params) {
            return '';
        },
        'organizer-revoked-micro-permission': function (params) {
            return '';
        },
        'organizer-revoked-summarization-permission': function (params) {
            return '';
        },
        'participants-button-title': function (params) {
            return 'Katılımcılar';
        },
        'presenter-view': function (params) {
            return 'Sunum görünümü';
        },
        'quit-call-confirm-modal-confirm': function (params) {
            return 'Çık';
        },
        'quit-call-confirm-modal-content': function (params) {
            return 'Toplantı yayını sonlandırılacak';
        },
        'quit-call-confirm-modal-header': function (params) {
            return 'Toplantıdan çıkılsın mı?';
        },
        'recording-in-process': function (params) {
            return 'Kayıt';
        },
        'recording-place-cloud': function (params) {
            return 'Yandex Disk';
        },
        'recording-place-local': function (params) {
            return 'Bilgisayar';
        },
        'recording-stop': function (params) {
            return 'Durdur';
        },
        'share-desktop-button-started-title': function (params) {
            return 'Ekran paylaşımı sürüyor';
        },
        'share-desktop-button-stop-title': function (params) {
            return 'Durdur';
        },
        'share-desktop-button-title': function (params) {
            return 'Ekran paylaşımı';
        },
        'show-limitation-popup-description': function (params) {
            return 'Yalnızca ilk 30 dakika kaydedilir. Toplantıyı tümünün bilgisayar için olan sürümde kaydedebilirsiniz.';
        },
        'show-limitation-popup-download': function (params) {
            return 'Uygulamayı kur';
        },
        'start-broadcast': function (params) {
            return 'Yayını başlat';
        },
        'stop-broadcast': function (params) {
            return 'Yayını duraklat';
        },
        'summarization-mail-for-admins': function (params) {
            return 'Özet, eş düzenleyenlerde bulunacak';
        },
        'summarization-mail-for-participants': function (params) {
            return 'Özet e-posta olarak gönderilecek';
        },
        'summarization-no-permission-to-start': function (params) {
            return 'Not almayı eş düzenleyen başlatabilir';
        },
        'summarization-prepare': function (params) {
            return 'Not alma başlatılıyor...';
        },
        'summarization-running': function (params) {
            return 'Not tutuluyor...';
        },
        'summarization-start': function (params) {
            return 'YandexGPT ile not al';
        },
        'summarization-start-v2': function (params) {
            return "Not tutmak Alisa Pro'yu çalıştır";
        },
        'summarization-starting': function (params) {
            return 'Başlatılıyor...';
        },
        'summarization-starting-extended': function (params) {
            return 'Not alma başlatılıyor...';
        },
        'summarization-stop': function (params) {
            return 'Not almayı durdur';
        },
        'summarization-stop-extended': function (params) {
            return 'Not almayı durdur';
        },
        'summarization-stop-v2': function (params) {
            return 'Durdur';
        },
        'turn-off-camera': function (params) {
            return 'Kamerayı kapat';
        },
        'turn-off-mic': function (params) {
            return 'Mikrofonu kapat';
        },
        'turn-on-camera': function (params) {
            return 'Kamerayı aç';
        },
        'turn-on-mic': function (params) {
            return 'Mikrofonu aç';
        },
    };

    if (module && module.exports) {
        module.exports = i18n;
    } else {
        window.i18n = window.i18n || {};
        window.i18n['tr'] = i18n;
    }
})();
